import React, { useState, useContext, useEffect,  useRef, useMemo, useCallback } from "react";
import { useHistory, useParams } from "react-router-dom";

//pages & includes
import ManageSidebar from "../ManageSidebar";
import Switch from "react-switch";
import { Tab, Tabs } from 'react-bootstrap';

//functions
import {
  _t,
  getCookie,
  tableLoading,
  customStyle,
  timeToDate,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import {
  BASE_URL,
  SAAS_APPLICATION,
  saas_apiUrl,
  saas_apiParams,
  saas_form_data,
} from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import Select from "react-select";
import { ToastError, ToastSuccess } from "../../../../../functions/ToastShow";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

import MenuQRModal from "./MenuQRModal";
import RichTextEditor from "../../../../components/Common/RichTextEditor";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import { FoodContext } from "../../../../../contexts/Food";
// Style constants & static options extracted outside component for performance and maintainability
const branchActionStyles = {
  sectionCard: {
    backgroundColor: "#f8fafc",
    borderRadius: "10px",
    border: "1px solid #e2e8f0",
  },
  sectionIconBox: (bg, color) => ({
    width: "32px",
    height: "32px",
    backgroundColor: bg,
    color: color,
  }),
  sectionBadge: {
    fontSize: "12.5px",
    fontWeight: 600,
    borderRadius: "12px",
    backgroundColor: "#f1f5f9",
    color: "#334155",
    border: "1px solid #cbd5e1",
  },
  featureCard: (isChecked) => ({
    minHeight: "58px",
    backgroundColor: isChecked ? "#f0fdf4" : "#ffffff",
    border: isChecked ? "1.5px solid #10b981" : "1px solid #e2e8f0",
    boxShadow: isChecked ? "0 2px 4px rgba(16, 185, 129, 0.12)" : "none",
    transition: "all 0.18s ease-in-out",
    userSelect: "none",
  }),
  featureLabel: (isChecked) => ({
    fontSize: "14px",
    color: isChecked ? "#065f46" : "#334155",
  }),
  featureCheckbox: {
    width: "18px",
    height: "18px",
    accentColor: "#10b981",
    flexShrink: 0,
    cursor: "pointer",
  },
  truncateFileName: {
    maxWidth: "5rem",
    marginBottom: "-0.35rem",
  },
  tableScrollBox: {
    maxHeight: "15rem",
    overflow: "auto",
  },
  tableActionIcon: {
    fontSize: "22px",
  },
  tableColMinWidth: {
    minWidth: "60px",
  },
  tableEmptyTh: {
    borderBottomColor: "lightgray",
  },
  automationCard: (isActive) => ({
    border: `1px solid ${isActive ? "#86efac" : "#e2e8f0"}`,
    backgroundColor: isActive ? "#f0fdf4" : "#ffffff",
    boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
    transition: "all 0.2s ease",
  }),
  automationBadge: (isActive) => ({
    fontSize: "11px",
    fontWeight: 600,
    borderRadius: "6px",
    backgroundColor: isActive ? "#dcfce7" : "#f1f5f9",
    color: isActive ? "#15803d" : "#64748b",
  }),
  kotInput: {
    paddingLeft: "28px",
    height: "32px",
    fontSize: "14px",
    borderColor: "#cbd5e1",
  },
  kotIcon: {
    left: "10px",
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: "12.5px",
    pointerEvents: "none",
    zIndex: 2,
  },
  statusCard: (isActive) => ({
    backgroundColor: isActive ? "#f0fdf4" : "#f8fafc",
    borderRadius: "10px",
    border: `1px solid ${isActive ? "#86efac" : "#e2e8f0"}`,
    transition: "all 0.2s ease-in-out",
  }),
  statusCircle: (isActive) => ({
    width: "42px",
    height: "42px",
    backgroundColor: isActive ? "#dcfce7" : "#f1f5f9",
    color: isActive ? "#16a34a" : "#64748b",
  }),
  statusBadge: (isActive) => ({
    fontSize: "11px",
    fontWeight: 600,
    borderRadius: "6px",
    backgroundColor: isActive ? "#dcfce7" : "#e2e8f0",
    color: isActive ? "#15803d" : "#475569",
  }),
  fiscalStatusPill: (activeFiscalAuthority) =>
    activeFiscalAuthority
      ? {
          fontSize: "12.5px",
          fontWeight: 600,
          borderRadius: "20px",
          backgroundColor: activeFiscalAuthority.bg,
          color: activeFiscalAuthority.color,
          border: `1px solid ${activeFiscalAuthority.border}`,
          boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
          letterSpacing: "0.2px",
        }
      : {
          fontSize: "12.5px",
          fontWeight: 500,
          borderRadius: "20px",
          backgroundColor: "#f8fafc",
          color: "#64748b",
          border: "1px solid #e2e8f0",
        },
  fiscalBadgeDot: (color) => ({
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    backgroundColor: color,
    marginRight: "6px",
    display: "inline-block",
  }),
  fiscalAuthorityCard: (isSelected, auth) => ({
    border: `2px solid ${isSelected ? auth.activeColor : "#e2e8f0"}`,
    backgroundColor: isSelected ? auth.activeBg : "#ffffff",
    boxShadow: isSelected ? `0 2px 4px ${auth.shadowColor}` : "none",
    transition: "all 0.15s ease-in-out",
  }),
  fiscalAuthorityBadge: (isSelected, auth) => ({
    backgroundColor: isSelected ? auth.activeColor : "#f1f5f9",
    color: isSelected ? "#ffffff" : "#475569",
    fontWeight: 700,
    fontSize: "12.5px",
  }),
  checkbox16: {
    cursor: "pointer",
    width: "16px",
    height: "16px",
  },
  checkbox18: {
    width: "18px",
    height: "18px",
    accentColor: "#10b981",
  },
  fiscalConfigContainer: (activeAuth) => ({
    backgroundColor: "#ffffff",
    border: `1.5px solid ${activeAuth ? activeAuth.border : "#e2e8f0"}`,
    borderRadius: "8px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.04)",
  }),
  fiscalConfigBadge: (activeAuth) => ({
    backgroundColor: activeAuth ? activeAuth.bg : "#f1f5f9",
    color: activeAuth ? activeAuth.color : "#475569",
    border: `1px solid ${activeAuth ? activeAuth.border : "#cbd5e1"}`,
    fontSize: "11px",
    fontWeight: 600,
  }),
  fiscalLabel: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#334155",
    marginBottom: "5px",
  },
  formLabel: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#334155",
    marginBottom: "5px",
    display: "block",
  },
  formInput: {
    height: "38px",
    fontSize: "15px",
    borderRadius: "6px",
    borderColor: "#cbd5e1",
    backgroundColor: "#ffffff",
    color: "#1e293b",
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
  },
  inputSuffix: {
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
    fontSize: "12.5px",
    fontWeight: 600,
    color: "#64748b",
    zIndex: 2,
  },
};

const BranchInputField = React.memo(({
  label,
  name,
  value,
  type = "text",
  required = false,
  requiredShow = false,
  placeholder,
  col = "col-lg-3 col-md-6 col-12",
  maxLength,
  min,
  max,
  step,
  suffix,
  onChange,
  onKeyDown,
  style,
  id,
}) => {
  const isNumber = type === "number";

  const handleKeyDown = (evt) => {
    if (onKeyDown) {
      onKeyDown(evt);
      return;
    }
    if (isNumber && ["e", "E", "ArrowUp", "ArrowDown"].includes(evt.key)) {
      evt.preventDefault();
    }
  };

  return (
    <div className={`${col} mb-3`}>
      <label htmlFor={id || name} className="form-label" style={branchActionStyles.formLabel}>
        {label} {(required || requiredShow) && <span className="text-danger">*</span>}
      </label>
      <div className="position-relative">
        <input
          type={type}
          className="form-control"
          id={id || name}
          name={name}
          value={value !== undefined && value !== null ? value : ""}
          placeholder={placeholder}
          required={required}
          maxLength={maxLength}
          min={min}
          max={max}
          step={step}
          onChange={onChange}
          onKeyDown={handleKeyDown}
          onWheel={isNumber ? (e) => e.target.blur() : undefined}
          style={{
            ...branchActionStyles.formInput,
            ...(suffix ? { paddingRight: "36px" } : {}),
            ...style,
          }}
        />
        {suffix && (
          <span className="position-absolute" style={branchActionStyles.inputSuffix}>
            {suffix}
          </span>
        )}
      </div>
    </div>
  );
});


const POS_RECEIPT_CONFIG = [
  { id: "print_pos_both", value: "Both", labelKey: "Both" },
  { id: "print_pos_kitchen", value: "Kitchen", labelKey: "Kitchen Receipt" },
  { id: "print_pos_customer", value: "Customer", labelKey: "Customer Receipt" },
];

const POS_PAYMENT_CONFIG = [
  { id: "loop_pay", value: "loop_pay", labelKey: "Loop Pay" },
  { id: "keenu", value: "keenu", labelKey: "Keenu" },
  { id: "no", value: "no", labelKey: "No" },
];

const FISCAL_AUTHORITY_CONFIG = [
  {
    key: "fbrIntegration",
    badge: "FBR",
    titleKey: "FBR Integration",
    subtitleKey: "Federal Board of Revenue",
    activeColor: "#4f46e5",
    activeBg: "#eef2ff",
    shadowColor: "rgba(79, 70, 229, 0.15)",
  },
  {
    key: "sbrIntegration",
    badge: "SRB / SBR",
    titleKey: "SBR Integration",
    subtitleKey: "Sindh Revenue Board",
    activeColor: "#0891b2",
    activeBg: "#ecfeff",
    shadowColor: "rgba(8, 145, 178, 0.15)",
  },
  {
    key: "pbrIntegration",
    badge: "PRA / PBR",
    titleKey: "PBR Integration",
    subtitleKey: "Punjab Revenue Authority",
    activeColor: "#d97706",
    activeBg: "#fffbeb",
    shadowColor: "rgba(217, 119, 6, 0.15)",
  },
  {
    key: "cbrIntegration",
    badge: "CBR",
    titleKey: "CBR Integration",
    subtitleKey: "Capital Board of Revenue",
    activeColor: "#475569",
    activeBg: "#f8fafc",
    shadowColor: "rgba(71, 85, 105, 0.15)",
  },
  {
    key: "kpraIntegration",
    badge: "KPRA",
    titleKey: "KPRA Integration",
    subtitleKey: "Khyber Pakhtunkhwa Revenue",
    activeColor: "#059669",
    activeBg: "#ecfdf5",
    shadowColor: "rgba(5, 150, 105, 0.15)",
  },
];

const BranchAction = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const params = useParams();
  //getting context values here
  let {
    //common
    loading,
    setLoading,
    fetchCoverageList,
  } = useContext(SettingsContext);

    let {adminStaffForSearch, partyForSearch} = useContext(UserContext);
    const { foodForPOS } = useContext(FoodContext);
  
    let {
      //branch
      setGetBranchList,
      branchForListSearch,
      branchForSearch,
      MdIntegrationForSearch,
      setGetBranchforSearch,
      paymentTypeForSearch,
      //md accounts
      getMdIntegrationGroup,
    } = useContext(RestaurantContext);
  
    // States hook here
    //new group
    let [newBranch, setNewBranch] = useState({
      id:null,
      name: "",
      code: "",
      phn_no: "",
      address: "",
      delivery_time: "0",
      branch_tax: "0",
      consolidated_ip:"",
      ideal_food_cost:"",
      image: null,
      forcast_sale: "",
      barcode_enable: 0,
      customer_screen_image: null,
      customer_screen_real_time: 0,
      cancel_order: 0,
      cancel_order_time: "",
      payment_integration:"",
      fromTime: null,
      toTime: null,
      shift_end_timing: null,
      print_name: "",
      sntn_no: "",
      fp_chain_code: "",
      fp_pos_vendor_id: "",
      latitude:"",
      longitude:"",
      offline_enable: 0,
      order_pickup_time: "",
      order_complete_time: "",
      feedback_url:"",
      consolidated_kot:false,
      auto_accept: false,
      edit: false,
      editSlug: null,
      fbrIntegration: false,
      cbrIntegration: false,
      kpraIntegration: false,
      fbrPosRegistrationNo: "",
      fbrPosToken: "",
      fbrPctCode: "",
      sbrIntegration: false,
      pbrIntegration: false,
      sbrPaymentType: [],
      print_tax:"",
      sbrNtn: "",
      sbrPosId: "",
      sbrPos: "",
      sbrUserId: "",
      sbrUserPassword: "",
      uploading: false,
      paymentTypeTax: {
        paymentType: "",
        tax: 0,
      },
      sales_acc: null,
      food_item: null,
      status: true,
      direct_ip_print: 0,
      customer_counter_ip: "",
      print_pos_setting:"",
      max_qty_check_purchase: 0,
      max_pi_qty_check: 0,
      is_production_qty_editable: 0,
      table_waiter: 0,
      branch_self_order: 0,
      // New branches show digital menu item images unless this is switched off.
      dm_image_display: 1,
      dm_addon_image_display: 1,
      qsr_card_payment: 0,
      allow_negative_stock: 1,
      dc_edit: 0,
      item_wise_discount: 0,
      calculate_sub_recipe_cost: 0,
      require_all_items_ready_kds: 0,
      po_price_increase_pct: 0,
      kitchen_printer_ip: "",
      service_fees_person: "0",
      service_fees: "0",
      restaurant_name:"",
      journal_name: "",
      functional_area:"",
      budget_center:"",
      cost_center:"",
      retail_channel:"",
      sales_account: null,
      discount_account: null,
      tax_account: null,
      cogs_account: null,
      pos_fee_account: null,
      auto_purchase_manage: 0,
      default_to_branch_id: "",
      auto_replenish_document: "",
      province_id: "",
      city_id: "",
    });
    let [bankDrop, setBankDrop] = useState({
      restaurant_name: "",
      journal_name: "",
      functional_area: "",
      budget_center: "",
      cost_center: "",
      retail_channel: "",
      bank_drop_account: null,
      expense_account: null,
      trapped_account: null,
    });
    let [fgDiscard, setFgDiscard] = useState({
      restaurant_name: "",
      journal_name: "",
      functional_area: "",
      budget_center: "",
      cost_center: "",
      retail_channel: "",
      cogs_account: null,
      fg_discard_account: null,
    });
    
    let [menuData, setMenuData] = useState({
      header_text: "",
      link_text: "",
      links: [],
      terms_conditions: "",
      footer_desc: "",
      footer_desc: ""
    });
    
    const [showMenuQRModal, setShowMenuQRModal] = useState(false);

  const handleMenuLinkChange = (index, field, value) => {
    const updatedLinks = [...menuData.links];
    updatedLinks[index][field] = value;
    setMenuData({ ...menuData, links: updatedLinks });
  };

  const addMenuLinkRow = () => {
    setMenuData({ ...menuData, links: [...menuData.links, { label: "", link: "" }] });
  };

  const removeMenuLinkRow = (index) => {
    const updatedLinks = [...menuData.links];
    updatedLinks.splice(index, 1);
    setMenuData({ ...menuData, links: updatedLinks });
  };

  const [provinceList, setProvinceList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [mdAccounts, setMdAccounts] = useState([]);
  let [sbrPaymentType, setSbrPaymentType] = useState([]);
  const [key, setKey] = useState('branch');
  //search result
  let [searchedBranch, setSearchedBranch] = useState({
    list: null,
    searched: false,
  });
  // branch limit check
  let [checkBranchLimitState, setCheckBranchLimitState] = useState("HAS-LIMIT");
  let [paymentTypeTax, setPaymentTypeTax] = useState([]);
  //new Row
  const [newRow, setNewRow] = useState([]);
  let rowId = useRef(0);

    // Keenu integration rows & helpers
    const [keenuRows, setKeenuRows] = useState([]);
    let keenuRowId = useRef(0);

    const addKeenuRow = useCallback(() => {
      setKeenuRows((prev) => [
        ...prev,
        {
          id: keenuRowId.current++,
          user: null,
          user_id: "",
          till_id: "",
          keenu_id: "",
        },
      ]);
    }, []);

    const delKeenuRow = useCallback((id) => {
      setKeenuRows((prev) => prev.filter((item) => item.id !== id));
    }, []);

    const handleSetKeenuUser = useCallback((index, user) => {
      setKeenuRows((prev) => {
        if (!prev[index]) return prev;
        const copy = [...prev];
        copy[index] = {
          ...copy[index],
          user: user,
          user_id: user ? user.id : "",
        };
        return copy;
      });
    }, []);

    const handleKeenuInputChange = useCallback((index, field, value) => {
      setKeenuRows((prev) => {
        if (!prev[index] || prev[index][field] === value) return prev;
        const copy = [...prev];
        copy[index] = { ...copy[index], [field]: value };
        return copy;
      });
    }, []);

    const getFormattedKeenuIntegration = (rows, paymentIntegration) => {
      if (paymentIntegration !== "keenu" || !rows?.length) {
        return { valid: true, data: [] };
      }
      const userSet = new Set();
      const data = [];
      for (const row of rows) {
        const userId = row.user_id || row.user?.id;
        if (!userId) {
          return { valid: false, error: "Please select a user for all Keenu rows" };
        }
        if (userSet.has(userId)) {
          return { valid: false, error: "Can't select user multiple times in Keenu" };
        }
        userSet.add(userId);
        data.push({
          user_id: userId,
          till_id: row.till_id ? String(row.till_id).trim() : "",
          keenu_id: row.keenu_id ? String(row.keenu_id).trim() : "",
        });
      }
      return { valid: true, data };
    };

    const parseKeenuIntegration = (rawKeenu, staffList) => {
      let parsed = rawKeenu;
      if (typeof parsed === "string") {
        try {
          parsed = JSON.parse(parsed);
        } catch (e) {
          parsed = [];
        }
      }
      if (!Array.isArray(parsed)) return [];

      return parsed.map((item) => ({
        id: keenuRowId.current++,
        user_id: item?.user_id ?? "",
        user: staffList?.find((u) => String(u.id) === String(item?.user_id)) || null,
        till_id: item?.till_id ?? "",
        keenu_id: item?.keenu_id ?? "",
      }));
    };

  const addNewRow = () => {
    let newId = rowId.current
    // if(newOpeningStock.branch !== null){
    setNewRow((pre) => [...pre, {
      id: newId,
      user: null,
      printer_ip: ""
    }])
    rowId.current += 1;
  }

  const handleTimeChange = (key, value) => {
    setNewBranch({
      ...newBranch,
      [key]: value
    })
  }

  const delRow = (id) => {
    let row = [...newRow]
    row = row.filter((item, i) => id !== item.id);
    setNewRow(row);
  }

  //set image hook
  const handleItemImage = (e) => {
    setNewBranch({
      ...newBranch,
      [e.target.name]: e.target.files[0],
    });
    if (document.getElementById([e.target.name])) {
      document.getElementById([e.target.name]).value = '';
    }
  };

  //set each branch user wise 
  const handleSetUser = (index, user) => {
    newRow[index].user = user;
    setNewRow([...newRow]);
  }

  //set each branch ip
  const handlePrinterIp = (index, e) => {
    newRow[index].printer_ip = e.target.value;
    setNewRow([...newRow]);
  };

  // check branch limit
  const checkBranchLimit = () => {
    // check how many orders are left
    const url = saas_apiUrl + "/api/user-branch-limit-check?" + saas_apiParams;
    axios
      .get(url)
      .then((res) => {
        setCheckBranchLimitState(res.data);
      })
      .catch(() => {
        return "NO data";
      });
  };

  //useEffect == componentDidMount
  useEffect(() => {
    if (!MdIntegrationForSearch) {
      getMdIntegrationGroup();
    }
    if (typeof fetchCoverageList === "function") {
      fetchCoverageList("province", 1)
        .then(function (parsed) {
          setProvinceList(
            parsed && Array.isArray(parsed.activeList) ? parsed.activeList : []
          );
        })
        .catch(function () {
          setProvinceList([]);
        });
    }
    // check expiry
    // if (SAAS_APPLICATION == "YES") {
    //   (async () => {
    //     const saasBranchToken = setInterval(checkBranchLimit, 7200000);
    //     checkBranchLimit();

    //     return () => {
    //       clearInterval(saasBranchToken);
    //     };
    //   })();
    // }
  }, [fetchCoverageList]);

  //set Fbr Integration
  const handleFbrIntegration = () => {
    setNewBranch({
      ...newBranch,
      fbrIntegration: !newBranch.fbrIntegration,
      cbrIntegration: false,
      sbrIntegration: false,
      pbrIntegration: false,
    });
  };

  //set Cbr Integration
  const handleCbrIntegration = () => {
    setNewBranch({
      ...newBranch,
      cbrIntegration: !newBranch.cbrIntegration,
      fbrIntegration: false,
      sbrIntegration: false,
      pbrIntegration: false,
    });
  };

  //set srb Integration
  const handleSbrIntegration = () => {
    setNewBranch({
      ...newBranch,
      cbrIntegration: false,
      pbrIntegration: false,
      fbrIntegration: false,
      sbrIntegration: !newBranch.sbrIntegration,
    });
  };

  //set Pbr Integration
  const handlePbrIntegration = () => {
    setNewBranch({
      ...newBranch,
      fbrIntegration: false,
      cbrIntegration: false,
      sbrIntegration: false,
      pbrIntegration: !newBranch.pbrIntegration,
    });
  }

  useEffect(()=>{
    if(params.id && adminStaffForSearch && MdIntegrationForSearch !== null){
      setLoading(true);
      handleSetEdit(params.id);
    }
  },[adminStaffForSearch, MdIntegrationForSearch])

  // Unified Fiscal Authority Toggle Logic
  const handleToggleFiscalAuthority = (key) => {
    setNewBranch((curr) => ({
      ...curr,
      fbrIntegration: key === "fbrIntegration" ? !curr.fbrIntegration : false,
      cbrIntegration: key === "cbrIntegration" ? !curr.cbrIntegration : false,
      kpraIntegration: key === "kpraIntegration" ? !curr.kpraIntegration : false,
      sbrIntegration: key === "sbrIntegration" ? !curr.sbrIntegration : false,
      pbrIntegration: key === "pbrIntegration" ? !curr.pbrIntegration : false,
    }));
  };

  //acounts
  const handleSetAccounts = (name, acc) => {
    setNewBranch({
      ...newBranch,
      [name]: acc,
    })
  }

  // on change send req
  const handleChangeStatus = () => {
    setNewBranch({
      ...newBranch,
      status: !newBranch.status,
    })
  };

  // on change send req
  const handleChecked = () => {
    setNewBranch({
      ...newBranch,
      auto_accept: !newBranch.auto_accept,
    })
  };

  const handleKotCheck = () => {
    setNewBranch((curr) => ({
      ...curr,
      consolidated_kot: !curr.consolidated_kot,
    }))
  };

  const handleCancelItem = () => {
    setNewBranch((curr) => ({
      ...curr,
      cancel_order: curr.cancel_order ? 0 : 1,
    }))
  };

    const handleToggleBranchOption = (key) => {
      setNewBranch((curr) => ({
        ...curr,
        [key]: parseInt(curr[key]) === 1 ? 0 : 1,
      }));
    };

    const handlePoPriceIncreaseChange = useCallback((e) => {
      const val = e.target.value;
      if (val === "" || val === ".") {
        setNewBranch((curr) => ({
          ...curr,
          po_price_increase_pct: val,
        }));
        return;
      }
      const num = parseFloat(val);
      if (isNaN(num)) return;
      if (num < 0) {
        setNewBranch((curr) => ({
          ...curr,
          po_price_increase_pct: 0,
        }));
      } else if (num > 100) {
        setNewBranch((curr) => ({
          ...curr,
          po_price_increase_pct: 100,
        }));
      } else {
        setNewBranch((curr) => ({
          ...curr,
          po_price_increase_pct: val,
        }));
      }
    }, []);

    const branchFeatureCheckboxes = useMemo(() => [
      { key: "offline_enable", label: _t(t("Enable Offline")) },
      { key: "customer_screen_real_time", label: _t(t("Enable Customer Display Screen")) },
      { key: "barcode_enable", label: _t(t("Enable Barcode")) },
      { key: "item_wise_discount", label: _t(t("Item Wise Discount")) },
      { key: "table_waiter", label: _t(t("Show table in POS")) },
      {
        key: "branch_self_order",
        label: _t(t("Self Ordering")),
        subtitle: _t(t("(Branch Wise)")),
      },
      { key: "allow_negative_stock", label: _t(t("Allow Negative Stock")) },
      { key: "dc_edit", label: _t(t("Delivery Update")) },
      { key: "max_qty_check_purchase", label: _t(t("Max Qty Item Purchase")) },
      { key: "max_pi_qty_check", label: _t(t("Max Pi item limit")) },
      { key: "calculate_sub_recipe_cost", label: _t(t("Calculate Sub Recipe Cost")) },
      { key: "is_production_qty_editable", label: _t(t("Production Qty Editable")) },
      { key: "require_all_items_ready_kds", label: _t(t("Require All Items Ready (KDS)")) },
    ], [t]);

    const branchGeneralFields = useMemo(() => [
      { name: "name", label: _t(t("Name")), required: true, col: "col-lg-4 col-md-6 col-12", placeholder: "e.g. Uttara Branch" },
      { name: "code", label: _t(t("Code")), col: "col-lg-2 col-md-6 col-12", placeholder: "e.g. 0012", maxLength: 13 },
      { name: "address", label: _t(t("Address")), col: "col-lg-6 col-md-12 col-12", placeholder: "Type branch address" },
      { name: "phn_no", label: _t(t("Phone number")), required: true, col: "col-lg-3 col-md-6 col-12", placeholder: "e.g. 01xxx xxx xxx" },
      { name: "branch_tax", label: _t(t("Branch Tax")), type: "number", required: true, col: "col-lg-3 col-md-6 col-12", placeholder: "0", maxLength: 99 },
      { name: "delivery_time", label: _t(t("Delivery Time")), required: true, col: "col-lg-3 col-md-6 col-12", placeholder: "0" },
      { name: "service_fees", label: _t(t("Service Charges")), col: "col-lg-3 col-md-6 col-12", placeholder: "0" },
      { name: "customer_counter_ip", label: _t(t("Delivery Counter IP")), col: "col-lg-3 col-md-6 col-12", placeholder: "e.g. 123.168.0.1" },
      { name: "service_fees_person", label: _t(t("Service Charges on Person")), type: "number", col: "col-lg-3 col-md-6 col-12", placeholder: "0", maxLength: 99 },
      { name: "print_tax", label: _t(t("Print Tax")), required: true, col: "col-lg-3 col-md-6 col-12", placeholder: "e.g. GST", maxLength: 50 },
      { name: "ideal_food_cost", label: _t(t("Ideal Food Cost")), col: "col-lg-3 col-md-6 col-12", placeholder: "e.g 10%" },
      { name: "fp_chain_code", label: _t(t("FP Chain Code")), col: "col-lg-3 col-md-6 col-12", placeholder: "e.g. abc" },
      { name: "fp_pos_vendor_id", label: _t(t("FP POS Vendor ID")), col: "col-lg-3 col-md-6 col-12", placeholder: "e.g. xyz" },
      { name: "latitude", label: _t(t("Latitude")), type: "number", col: "col-lg-3 col-md-6 col-12", placeholder: "e.g. 50.41" },
      { name: "longitude", label: _t(t("Longitude")), type: "number", col: "col-lg-3 col-md-6 col-12", placeholder: "e.g. 46.78" },
      { name: "feedback_url", label: _t(t("Feedback Url")), col: "col-lg-4 col-md-6 col-12", placeholder: "e.g. https://.." },
      {
        name: "forcast_sale",
        id: "sale",
        label: _t(t("Forecasting Sale")),
        type: "number",
        col: "col-lg-4 col-md-6 col-12",
        placeholder: "Forcast sale",
        onKeyDown: (evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault(),
      },
      {
        name: "po_price_increase_pct",
        label: _t(t("PO Price Increase %")),
        type: "number",
        col: "col-lg-4 col-md-6 col-12",
        placeholder: "e.g. 10",
        min: "0",
        max: "100",
        step: "any",
        suffix: "%",
        onChange: handlePoPriceIncreaseChange,
        onKeyDown: (evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault(),
      },
    ], [t, handlePoPriceIncreaseChange]);

    const activeFiscalAuthority = useMemo(() => {
      if (newBranch.fbrIntegration) {
        return {
          name: "FBR",
          fullName: _t(t("Federal Board of Revenue")),
          color: "#4338ca",
          bg: "#e0e7ff",
          border: "#c7d2fe",
          icon: "fa-check-circle",
        };
      }
      if (newBranch.sbrIntegration) {
        return {
          name: "SBR",
          fullName: _t(t("Sindh Revenue Board")),
          color: "#0e7490",
          bg: "#cffafe",
          border: "#a5f3fc",
          icon: "fa-check-circle",
        };
      }
      if (newBranch.pbrIntegration) {
        return {
          name: "PBR",
          fullName: _t(t("Punjab Revenue Authority")),
          color: "#b45309",
          bg: "#fef3c7",
          border: "#fde68a",
          icon: "fa-check-circle",
        };
      }
      if (newBranch.cbrIntegration) {
        return {
          name: "CBR",
          fullName: _t(t("Capital Board of Revenue")),
          color: "#334155",
          bg: "#f1f5f9",
          border: "#cbd5e1",
          icon: "fa-check-circle",
        };
      }
      if (newBranch.kpraIntegration) {
        return {
          name: "KPRA",
          fullName: _t(t("Khyber Pakhtunkhwa Revenue")),
          color: "#047857",
          bg: "#d1fae5",
          border: "#a7f3d0",
          icon: "fa-check-circle",
        };
      }
      return null;
    }, [
      t,
      newBranch.fbrIntegration,
      newBranch.sbrIntegration,
      newBranch.pbrIntegration,
      newBranch.cbrIntegration,
      newBranch.kpraIntegration,
    ]);

  //set each variation price
  const handlePaymentTypeTax = (e) => {
    setPaymentTypeTax({
      ...paymentTypeTax,
      [e.target.name]: e.target.value,
    });

  };

  //set name, phn no, address hook
  const handleSetNewBranch = (e) => {
    setNewBranch({ ...newBranch, [e.target.name]: e.target.value });
  };

  const fetchCitiesByProvince = (provinceId) => {
    if (provinceId == null || provinceId === "") {
      setCityList([]);
      return;
    }
    axios
      .get(BASE_URL + "/settings/city/get-by-province/" + provinceId, {
        headers: { Authorization: "Bearer " + getCookie() },
      })
      .then(function (res) {
        const data =
          res && res.data && Array.isArray(res.data.data) ? res.data.data : [];
        setCityList(data);
      })
      .catch(function () {
        setCityList([]);
      });
  };

  const handleProvinceChange = (option) => {
    const provinceId = option && option.id != null ? option.id : "";
    setNewBranch({
      ...newBranch,
      province_id: provinceId,
      city_id: "",
    });
    fetchCitiesByProvince(provinceId);
  };

  const handleCityChange = (option) => {
    setNewBranch({
      ...newBranch,
      city_id: option && option.id != null ? option.id : "",
    });
  };

  const handleSetPaymentType = (paymentTypes) => {
    // setNewBranch({
    //   ...newBranch,
    //   sbrPaymentType: [paymentTypes],
    // });
    setSbrPaymentType(paymentTypes);
  };


  // change in each row
  const handleSetChange = (index, e) => {
    mdAccounts[index][e.target.name] = e.target.value;
    setMdAccounts([...mdAccounts]);
  }

  // change in each row select
  const handleSetSelectChange = (index, name, value) => {
    mdAccounts[index][name] = value;
    setMdAccounts([...mdAccounts]);
  }

  const addNewMdRow = () => {
    setMdAccounts((pre) => [...pre, {
      party: "",
      restaurant_name: "",
      journal_name: "",
      functional_area: "",
      budget_center: "",
      cost_center: "",
      retail_channel: "",
      sales_account: null,
      discount_account: null,
      tax_account: null,
      cogs_account: null,
      pos_fee_account: null,
    }])
  }

  const delMdRow = (index) => {
    let row = [...mdAccounts];
    if (index > -1) {
      row.splice(index, 1);
    }
    setMdAccounts(row);
  }

  //Save New branch
  const handleSaveNewBranch = (e) => {
    e.preventDefault();
    let deliveryIp = {};

    newRow?.length && newRow.forEach((ip) => {
      if (ip.user !== null && ip.user !== "" && typeof (ip.user) == "object") {
        deliveryIp = {
          ...deliveryIp,
          [ip.user.id]: ip.printer_ip,
        }
      }
    });

    if (Object.keys(deliveryIp)?.length !== newRow?.length) {
      ToastError({ title: `${_t(t("Select User/Can't select user multiple time"))}` })
      return false
    }

    const keenuCheck = getFormattedKeenuIntegration(keenuRows, newBranch.payment_integration);
    if (!keenuCheck.valid) {
      ToastError({ title: `${_t(t(keenuCheck.error))}` });
      return false;
    }
    const keenuIntegration = keenuCheck.data;

    if (key === "pi_microsoft" && newBranch.restaurant_name) {
      if (!newBranch.restaurant_name || !newBranch.journal_name || !newBranch.budget_center ||
        !newBranch.functional_area || !newBranch.cost_center || !newBranch.retail_channel || (!newBranch.sales_account) ||
        !newBranch.cogs_account || !newBranch.pos_fee_account || !newBranch.discount_account || !newBranch.tax_account) {
        ToastError({ title: `${_t(t("Please select all required fields for PI Microsoft"))}` })
        return;
      }
    }

    const mdAcc = [];
    const dupParty = {};
    const dupPartyName = []

    if (mdAccounts && mdAccounts?.length) {
      mdAccounts.forEach((acc) => {
        if (!acc.party || !acc.restaurant_name || !acc.journal_name || !acc.budget_center ||
          !acc.functional_area || !acc.cost_center || !acc.retail_channel || (!acc.sales_account) ||
          !acc.cogs_account || !acc.pos_fee_account || !acc.discount_account || !acc.tax_account) {
        } else {
          if (dupParty[acc.party.id]) {
            dupPartyName.push(acc.party.name);
          }
          dupParty[acc.party.id] = true;
          mdAcc.push({
            party_id: acc.party.id,
            restaurant_name: acc.restaurant_name,
            journal_name: acc.journal_name,
            budget_center: acc.budget_center,
            functional_area: acc.functional_area,
            cost_center: acc.cost_center,
            retail_channel: acc.retail_channel,
            sales_account: acc.sales_account.id,
            discount_account: acc.discount_account.id,
            tax_account: acc.tax_account.id,
            cogs_account: acc.cogs_account.id,
            pos_fee_account: acc.pos_fee_account.id
          })
        }
      })
    }

    if (mdAccounts?.length !== mdAcc?.length) {
      ToastError({ title: `${_t(t("Please select all required fields for MD"))}` })
      return;
    }

    // console.log("mdAccounts", mdAccounts,mdAcc);


    if (dupPartyName && dupPartyName?.length) {
      ToastError({ title: `${_t(t(`Duplicate party ${dupPartyName[0]}`))}` })
      return;
    }

    if (newBranch?.sales_acc?.id && (!newBranch.food_item || newBranch.food_item?.length === 0)) {
      ToastError({ title: `${_t(t(`Please select item`))}` })
      return;
    }

    const mdAccPI = newBranch.restaurant_name ? [{
      restaurant_name: newBranch.restaurant_name,
      journal_name: newBranch.journal_name,
      functional_area: newBranch.functional_area,
      budget_center: newBranch.budget_center,
      cost_center: newBranch.cost_center,
      retail_channel: newBranch.retail_channel,
      sales_account: newBranch.sales_account?.id ? newBranch.sales_account?.id : "",
      discount_account: newBranch.discount_account?.id ? newBranch.discount_account?.id : "",
      tax_account: newBranch.tax_account?.id ? newBranch.tax_account?.id : "",
      cogs_account: newBranch.cogs_account?.id ? newBranch.cogs_account?.id : "",
      pos_fee_account: newBranch.pos_fee_account?.id ? newBranch.pos_fee_account?.id : "",
    }] : [];

    const foodItem = newBranch.food_item?.length ? newBranch.food_item.map((item) => item.id) : [];

    const mdSaleAcc = newBranch.sales_acc && newBranch.sales_acc?.id ? {
      sale_account_id: newBranch.sales_acc?.id,
      food_item_id: foodItem,
    } : [];

    let bankDropData = [];

    if (key === "bank_drop" || bankDrop.restaurant_name) {
      if (!bankDrop.restaurant_name || !bankDrop.journal_name || !bankDrop.functional_area || !bankDrop.budget_center || !bankDrop.cost_center || !bankDrop.retail_channel || (!bankDrop.bank_drop_account) || (!bankDrop.expense_account) || (!bankDrop.trapped_account)) {
        ToastError({ title: `${_t(t("Please select all required fields for bank drop"))}` })
        return;
      }
      const bdId = bankDrop.bank_drop_account?.id;
      const expId = bankDrop.expense_account?.id;
      const trapId = bankDrop.trapped_account?.id;
      if (bdId === expId || bdId === trapId || expId === trapId) {
        ToastError({ title: `${_t(t("Bank drop account, expense account and trapped account must be different from each other"))}` })
        return;
      }

      bankDropData.push({
        restaurant_name: bankDrop.restaurant_name,
        journal_name: bankDrop.journal_name,
        functional_area: bankDrop.functional_area,
        budget_center: bankDrop.budget_center,
        cost_center: bankDrop.cost_center,
        retail_channel: bankDrop.retail_channel,
        bank_drop_account: bankDrop.bank_drop_account.id,
        expense_account: bankDrop.expense_account.id,
        trapped_account: bankDrop.trapped_account.id,
      })
    }

    let wastageAccountData = [];
    if (key === "fg_discard" || fgDiscard.restaurant_name) {
      if (!fgDiscard.restaurant_name || !fgDiscard.journal_name || !fgDiscard.functional_area || !fgDiscard.budget_center || !fgDiscard.cost_center || !fgDiscard.retail_channel || !fgDiscard.cogs_account || !fgDiscard.fg_discard_account) {
        ToastError({ title: `${_t(t("Please select all required fields for FG discard"))}` });
        return;
      }
      wastageAccountData.push({
        restaurant_name: fgDiscard.restaurant_name,
        journal_name: fgDiscard.journal_name,
        functional_area: fgDiscard.functional_area,
        budget_center: fgDiscard.budget_center,
        cost_center: fgDiscard.cost_center,
        retail_channel: fgDiscard.retail_channel,
        cogs_account: fgDiscard.cogs_account.id,
        fg_discard_account: fgDiscard.fg_discard_account.id,
      });
    }

    let fromTime = newBranch.fromTime ? moment(newBranch.fromTime).format('HH:mm') : "";
    let toTime = newBranch.toTime ? moment(newBranch.toTime).format('HH:mm') : "";
    let shiftEndTiming = newBranch.shift_end_timing ? moment(newBranch.shift_end_timing).format('HH') : "";

        setNewBranch({
          ...newBranch,
          uploading: true,
        });
        const branchUrl = BASE_URL + `/settings/new-branch`;
        let formData = new FormData();
        formData.append("name", newBranch.name);
        formData.append("code", newBranch.code);
        formData.append("phn_no", newBranch.phn_no);
        formData.append("address", newBranch.address);
        formData.append("province_id", newBranch.province_id || "");
        formData.append("city_id", newBranch.city_id || "");
        formData.append("delivery_time", newBranch.delivery_time);
        formData.append("branch_tax", newBranch.branch_tax);
        formData.append("branch_logo", newBranch.image);
        formData.append("forcast_sale", newBranch.forcast_sale || 0);
        formData.append("barcode_enable", formData.barcode_enable ?? 0);
        formData.append("customer_screen_image", newBranch.customer_screen_image);
        formData.append("customer_screen_real_time", newBranch.customer_screen_real_time);
        formData.append("cancel_order", newBranch.cancel_order);
        formData.append("cancel_order_time", newBranch.cancel_order_time);
        formData.append("payment_integration", newBranch.payment_integration);
        formData.append("keenu_integration", JSON.stringify(keenuIntegration));
        formData.append("from_purchase_time", fromTime);
        formData.append("to_purchase_time", toTime);
        formData.append("shift_end_timing", shiftEndTiming);
        formData.append("print_name", newBranch.print_name);
        formData.append("sntn_no", newBranch.sntn_no);
        formData.append("fp_chain_code", newBranch.fp_chain_code);
        formData.append("fp_pos_vendor_id", newBranch.fp_pos_vendor_id);
        formData.append("longitude", newBranch.longitude);
        formData.append("offline_enable", newBranch.offline_enable);
        formData.append("order_pickup_time", newBranch.order_pickup_time);
        formData.append("order_complete_time", newBranch.order_complete_time);
        formData.append("feedback_url", newBranch.feedback_url)
        formData.append("latitude", newBranch.latitude);
        formData.append("fbr_integration", newBranch.fbrIntegration);
        formData.append("cbr_integration", newBranch.cbrIntegration);
        formData.append("kpra_integration", newBranch.kpraIntegration);
        formData.append("pbr_integration", newBranch.pbrIntegration);
        formData.append("fbr_pos_registration_no", newBranch.fbrPosRegistrationNo);
        formData.append("fbr_pos_token", newBranch.fbrPosToken);
        formData.append("fbr_pct_code", newBranch.fbrPctCode);
        formData.append("sbr_integration", newBranch.sbrIntegration);
        formData.append("status", newBranch.status);
        //   formData.append("sbr_payment_type", newBranch.sbrPaymentType);
        formData.append("sbr_ntn", newBranch.sbrNtn);
        formData.append("sbr_pos_id", newBranch.sbrPosId);
        formData.append("sbr_user_id", newBranch.sbrUserId);
        formData.append("sbr_user_password", newBranch.sbrUserPassword);
        formData.append("direct_ip_print", newBranch.direct_ip_print);
        formData.append("customer_counter_ip", newBranch.customer_counter_ip);
        formData.append("print_pos_setting", newBranch.print_pos_setting);
        formData.append("max_qty_check_purchase", newBranch.max_qty_check_purchase);
        formData.append("max_pi_qty_check", newBranch.max_pi_qty_check);
        formData.append("is_production_qty_editable", newBranch.is_production_qty_editable);
        formData.append("table_waiter", newBranch.table_waiter);
        formData.append("branch_self_order", newBranch.branch_self_order);
        // Persist the image display preference with the rest of the branch settings.
        formData.append("dm_image_display", newBranch.dm_image_display);
        formData.append("dm_addon_image_display", newBranch.dm_addon_image_display ?? 1);
        formData.append("qsr_card_payment", newBranch.qsr_card_payment ?? 0);
        formData.append("allow_negative_stock", newBranch.allow_negative_stock);
        formData.append("dc_edit", newBranch.dc_edit);
        formData.append("item_wise_discount", newBranch.item_wise_discount);
        formData.append("calculate_sub_recipe_cost", newBranch.calculate_sub_recipe_cost);
        formData.append("require_all_items_ready_kds", newBranch.require_all_items_ready_kds);
        formData.append("po_price_increase_pct", newBranch.po_price_increase_pct || 0);
        formData.append("kitchen_printer_ip", JSON.stringify(deliveryIp));
        formData.append("auto_purchase_manage", newBranch.auto_purchase_manage);
        formData.append("default_to_branch_id", newBranch.default_to_branch_id);
        formData.append("auto_replenish_document", newBranch.auto_replenish_document || "");
        formData.append("service_fees_person", newBranch.service_fees_person);
        formData.append("service_fees", newBranch.service_fees);
        formData.append("print_tax", newBranch.print_tax);
        formData.append("auto_accept", newBranch.auto_accept ? 1 : 0);
        formData.append("consolidated_kot", newBranch.consolidated_kot ? 1 : 0); 
        formData.append("consolidated_ip", newBranch.consolidated_ip);  
        formData.append("ideal_food_cost", newBranch.ideal_food_cost || 0); 
        formData.append("md_accounts", JSON.stringify(mdAcc));
        formData.append("md_accPI", JSON.stringify(mdAccPI));
        formData.append("md_item_accounts", JSON.stringify(mdSaleAcc));
        formData.append("bank_drop", JSON.stringify(bankDropData));
        formData.append("md_accFgd", JSON.stringify(wastageAccountData));
        formData.append("menu", JSON.stringify(menuData));
        formData.append("footer_desc", menuData.footer_desc || "");

        let tempArray = [];
        sbrPaymentType.map((Item) => {
          tempArray.push(Item.id);
        });
        formData.append("payment_type_id", tempArray);
    
        let tempData = Object.entries(paymentTypeTax);
        tempData.map((item) => {
          formData.append("payment_type_tax[]", item);
        });
    
        return axios
          .post(branchUrl, formData, {
            headers: { Authorization: `Bearer ${getCookie()}` },
          })
          .then((res) => {
            if (SAAS_APPLICATION == "YES") {
              // after send api req decremeny by one
              const url = saas_apiUrl + "/api/user-branch-limit-decrement"; // replace with base url (prince.thetestserver.xyz)
              axios
                .post(url, saas_form_data)
                .then((res) => {
                  console.log(res);
                })
                .catch(() => {
                  return "NO data";
                });
            }
            setNewBranch({
              id:null,
              name: "",
              code: "",
              phn_no: "",
              address: "",
              province_id: "",
              city_id: "",
              delivery_time: "0",
              branch_tax: "0",
              consolidated_ip:"",
              forcast_sale: "",
              barcode_enable: 0,
              ideal_food_cost:"",
              latitude:"",
              longitude:"",
              order_pickup_time: "",
              order_complete_time: "",
              feedback_url:"",
              image: null,
              customer_screen_image: null,
              customer_screen_real_time: 0,
              cancel_order: 0,
              cancel_order_time:"",
              payment_integration:"",
              fromTime: null,
              toTime: null,
              shift_end_timing: null,
              print_name: "",
              sntn_no: "",
              fp_chain_code: "",
              fp_pos_vendor_id: "",
              auto_accept: false,
              consolidated_kot: false,
              status: true,
              edit: false,
              fbrIntegration: false,
              cbrIntegration: false,
              kpraIntegration: false,
              pbrIntegration:false,
              fbrPosRegistrationNo: "",
              fbrPosToken: "",
              fbrPctCode: "",
              sbrIntegration: false,
              sbrPaymentType: [],
              sales_acc: null,
              food_item: null,
              sbrNtn: "",
              sbrPosId: "",
              sbrUserId: "",
              sbrUserPassword: "",
              editSlug: null,
              uploading: false,
              kitchen_printer_ip: "",
              service_fees_person: "0",
              direct_ip_print: 0,
              customer_counter_ip: "",
              print_pos_setting:"",
              max_qty_check_purchase: 0,
              max_pi_qty_check: 0,
              is_production_qty_editable: 0,
              table_waiter: 0,
              branch_self_order: 0,
              dm_image_display: 1,
              dm_addon_image_display: 1,
              qsr_card_payment: 0,
              allow_negative_stock: 1,
              dc_edit: 0,
              auto_purchase_manage: 0,
              default_to_branch_id: "",
              auto_replenish_document: "",
              item_wise_discount: 0,
              calculate_sub_recipe_cost: 0,
              require_all_items_ready_kds: 0,
              po_price_increase_pct: 0,
              service_fees: "0",
              print_tax:"",
            });
            setBankDrop({
              restaurant_name: "",
              journal_name: "",
              functional_area: "",
              budget_center: "",
              cost_center: "",
              retail_channel: "",
              bank_drop_account: null,
              expense_account: null,
              trapped_account: null,
            });
            setFgDiscard({
              restaurant_name: "",
              journal_name: "",
              functional_area: "",
              budget_center: "",
              cost_center: "",
              retail_channel: "",
              cogs_account: null,
              fg_discard_account: null,
            });
            setMenuData({
              header_text: "",
              link_text: "",
              links: [],
              terms_conditions: "",
              footer_desc: ""
        });
        setNewRow([]);
        setKeenuRows([]);
        setGetBranchList(res.data[0]);
        setGetBranchforSearch(res.data[1]);
        setSearchedBranch({
          ...searchedBranch,
          list: res.data[1],
        });
        setLoading(false);
        ToastSuccess({ title: `${_t(t("Branch has been added"))}` })
        history.push("/dashboard/manage/restaurant/branches");
      })
      .catch((error) => {
        console.log("check error==>", error)
        setLoading(false);
        setNewBranch({
          ...newBranch,
          uploading: false,
        });
        ToastError({ title: `${_t(t("Please try again"))}` })
      });
  };


  //set edit true & values
  const handleSetEdit = async (id) => {
    try {
      const url = BASE_URL + '/settings/edit-branch/' + id;

      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });

      if (res.data) {
        const branch = res.data;
        let selectOptionsPayment = [];
        const paymentArray = branch?.payment_type_id && JSON.parse(branch?.payment_type_id);
        if (paymentArray) {
          if (paymentArray.length) {
            for (let property of paymentArray) {
              const paymentType = paymentTypeForSearch.find((item) => item.id == property);
              if (paymentType) {
                selectOptionsPayment.push(paymentType);
              }
            }
          }
        }
        setSbrPaymentType(selectOptionsPayment);

        let deliveryIp = JSON.parse(branch?.kitchen_printer_ip);
        deliveryIp && adminStaffForSearch && Object.entries(deliveryIp).forEach((key) => {
          let user = adminStaffForSearch.find((users) => users.id == key[0])
          let newId = rowId.current
          setNewRow((pre) =>
            [...pre, {
              id: newId,
              printer_ip: key[1],
              user: user,
            }])
          rowId.current += 1;
        })

        setKeenuRows(parseKeenuIntegration(branch?.keenu_integration, adminStaffForSearch));
        let accountSale1, accountDiscount1, accountTax1, accountCogs1, accountRevenue1 = null;
        let bdAcc, trapAcc, expAcc = null;
        let waCogsAcc, waWastageAcc = null;

        MdIntegrationForSearch && (branch?.md_accPI || branch?.md_accBD?.restaurant_name || branch?.md_accWA?.restaurant_name) && MdIntegrationForSearch.forEach((item) => {
          if (branch?.md_accPI) {
            if (item.id === parseInt(branch.md_accPI?.sales_account)) accountSale1 = item;
            if (item.id === parseInt(branch.md_accPI?.discount_account)) accountDiscount1 = item;
            if (item.id === parseInt(branch.md_accPI?.tax_account)) accountTax1 = item;
            if (item.id === parseInt(branch.md_accPI?.cogs_account)) accountCogs1 = item;
            if (item.id === parseInt(branch.md_accPI?.pos_fee_account)) accountRevenue1 = item;
          }
          if (branch?.md_accBD?.restaurant_name) {
            if (item.id === parseInt(branch.md_accBD?.bank_drop_account)) bdAcc = item;
            if (item.id === parseInt(branch.md_accBD?.expense_account)) expAcc = item;
            if (item.id === parseInt(branch.md_accBD?.trapped_account)) trapAcc = item;
          }
          if (branch?.md_accFgd?.restaurant_name) {
            if (item.id === parseInt(branch.md_accFgd?.cogs_account)) waCogsAcc = item;
            if (item.id === parseInt(branch.md_accFgd?.fg_discard_account)) waWastageAcc = item;
          }
        });

        setBankDrop({
          restaurant_name: branch?.md_accBD?.restaurant_name ?? "",
          journal_name: branch?.md_accBD?.journal_name ?? "",
          functional_area: branch?.md_accBD?.functional_area ?? "",
          budget_center: branch?.md_accBD?.budget_center ?? "",
          cost_center: branch?.md_accBD?.cost_center ?? "",
          retail_channel: branch?.md_accBD?.retail_channel ?? "",
          bank_drop_account: bdAcc,
          expense_account: expAcc,
          trapped_account: trapAcc,
        });

          setFgDiscard({
            restaurant_name: branch?.md_accFgd?.restaurant_name ?? "",
            journal_name: branch?.md_accFgd?.journal_name ?? "",
            functional_area: branch?.md_accFgd?.functional_area ?? "",
            budget_center: branch?.md_accFgd?.budget_center ?? "",
            cost_center: branch?.md_accFgd?.cost_center ?? "",
            retail_channel: branch?.md_accFgd?.retail_channel ?? "",
            cogs_account: waCogsAcc ?? null,
            cogs_account: waCogsAcc ?? null,
            fg_discard_account: waWastageAcc ?? null,
          });
          
          let parsedMenu = branch?.menu;
          if (typeof parsedMenu === "string") {
            try {
              parsedMenu = JSON.parse(parsedMenu);
            } catch (e) {
              parsedMenu = {};
            }
          }

          setMenuData({
            header_text: parsedMenu?.header_text || "",
            link_text: parsedMenu?.link_text || "",
            links: parsedMenu?.links?.length ? (parsedMenu.links) : [],
            terms_conditions: parsedMenu?.terms_conditions || branch?.terms_conditions || "",
            footer_desc: parsedMenu?.footer_desc || branch?.footer_desc || ""
          });

        if (branch?.md_accounts && branch.md_accounts?.length) {
          const mdAcc = [];
          branch.md_accounts.forEach((brach) => {
            let accountSale, accountDiscount, accountTax, accountCogs, accountRevenue = null;
            MdIntegrationForSearch && MdIntegrationForSearch.forEach((item) => {
              if (item.id === parseInt(brach.sales_account)) accountSale = item;
              if (item.id === parseInt(brach.discount_account)) accountDiscount = item;
              if (item.id === parseInt(brach.tax_account)) accountTax = item;
              if (item.id === parseInt(brach.cogs_account)) accountCogs = item;
              if (item.id === parseInt(brach.pos_fee_account)) accountRevenue = item;
            });
            const party = partyForSearch.find((party) => party.id === brach.party_id);

            // console.log("party", party,partyForSearch,brach.party_id);

            mdAcc.push({
              party: party,
              restaurant_name: brach?.restaurant_name,
              journal_name: brach?.journal_name,
              functional_area: brach?.functional_area,
              budget_center: brach?.budget_center,
              cost_center: brach?.cost_center,
              retail_channel: brach?.retail_channel,
              sales_account: accountSale,
              discount_account: accountDiscount,
              tax_account: accountTax,
              cogs_account: accountCogs,
              pos_fee_account: accountRevenue,
            })
          })
          setMdAccounts(mdAcc);
        }

        const saleAcccount = MdIntegrationForSearch && branch.md_item_accounts[0]?.sale_account_id ? MdIntegrationForSearch.find((item) => item.id === parseInt(branch.md_item_accounts[0]?.sale_account_id)) : null;
        const foodItemIdSet = new Set(branch?.md_item_accounts[0]?.items ?? []);
        const foodItem = branch.md_item_accounts[0]?.items?.length ? foodForPOS.filter((item) => {
          return foodItemIdSet.has(item.id)
        }) : null;

          let fromTime = branch.from_purchase_time ? timeToDate(branch.from_purchase_time) : "";
          let toTime = branch.to_purchase_time ? timeToDate(branch.to_purchase_time) : "";
          let shiftEndTiming = branch.shift_end_timing !== null && branch.shift_end_timing !== undefined && branch.shift_end_timing !== "" ? moment(branch.shift_end_timing, "HH").toDate() : null;
          
          setNewBranch({
            ...newBranch, 
            id: branch.id,
            name: branch.name,
            code: branch.code,
            phn_no: branch.phn_no,
            address: branch.address,
            province_id: branch.province_id || "",
            city_id: branch.city_id || "",
            delivery_time: branch.delivery_time,
            forcast_sale: branch.forcast_sale,
            barcode_enable: branch?.barcode_enable ?? 0,
            branch_tax: branch.branch_tax,
            fromTime: fromTime,
            toTime: toTime,
            shift_end_timing: shiftEndTiming,
            auto_accept: JSON.parse(branch.auto_accept),
            consolidated_kot: parseInt(branch.consolidated_kot) ? true : false,
            consolidated_ip: branch.consolidated_ip,
            ideal_food_cost: branch?.ideal_food_cost || "",
            image: null,
            customer_screen_image: null,
            customer_screen_real_time: branch.customer_screen_real_time,
            cancel_order: branch.cancel_order,
            cancel_order_time: branch.cancel_order_time,
            payment_integration: branch.payment_integration,
            sales_acc: saleAcccount,
            food_item: foodItem,
            print_name: branch?.print_name ?? "",
            sntn_no: branch?.sntn_no ?? "",
            fp_chain_code: branch?.fp_chain_code ?? "",
            fp_pos_vendor_id: branch?.fp_pos_vendor_id ?? "",
            editSlug: branch.slug,
            status: parseInt(branch.status) ? true : false,
            fbrIntegration: parseInt(branch.fbr_integration) === 1 ? true : false,
            cbrIntegration: parseInt(branch.cbr_integration) === 1 ? true : false,
            kpraIntegration: parseInt(branch.kpra_integration) === 1 ? true : false,
            pbrIntegration: parseInt(branch.pbr_integration) === 1 ? true : false,
            fbrPosRegistrationNo: branch.fbr_pos_registration_no,
            fbrPosToken: branch.fbr_pos_token,
            fbrPctCode: branch.fbr_pct_code,
            payment_tax: branch.payment_tax,
            sbrIntegration: parseInt(branch.sbr_integration) === 1 ? true : false,
            sbrPaymentType: branch.sbr_payment_type,
            sbrNtn: branch.sbr_ntn,
            sbrPosId: branch.sbr_pos_id,
            sbrUserId: branch.sbr_user_id,
            sbrUserPassword: branch.sbr_user_password,
            direct_ip_print: parseInt(branch.direct_ip_print),
            customer_counter_ip: branch.customer_counter_ip,
            print_pos_setting: branch.print_pos_setting,
            max_qty_check_purchase: branch.max_qty_check_purchase,
            max_pi_qty_check: branch?.max_pi_qty_check ?? 0,
            is_production_qty_editable: branch?.is_production_qty_editable ?? 0,
            table_waiter: branch.table_waiter,
            branch_self_order: branch?.branch_self_order ?? 0,
            allow_negative_stock: branch?.allow_negative_stock ?? 0,
            dc_edit: branch?.dc_edit ?? 0,
            dm_image_display: branch?.dm_image_display ?? 1,
            auto_purchase_manage: branch?.auto_purchase_manage ?? 0,
            default_to_branch_id: branch?.default_to_branch_id ?? "",
            auto_replenish_document: branch?.auto_replenish_document ?? "",
            // Keep older branches enabled by default when the API has no value yet.
            dm_image_display: branch?.dm_image_display ?? 1,
            dm_addon_image_display: branch?.dm_addon_image_display ?? 1,
            qsr_card_payment: branch?.qsr_card_payment ?? 0,
            allow_negative_stock: branch?.allow_negative_stock ?? 0,
            dc_edit: branch?.dc_edit ?? 0,
            auto_purchase_manage: branch?.auto_purchase_manage ?? 0,
            default_to_branch_id: branch?.default_to_branch_id ?? "",
            auto_replenish_document: branch?.auto_replenish_document ?? "",
            item_wise_discount: branch?.item_wise_discount ?? 0,
            calculate_sub_recipe_cost: branch?.calculate_sub_recipe_cost ?? 0,
            po_price_increase_pct: branch?.po_price_increase_pct ?? 0,
            calculate_sub_recipe_cost: branch?.calculate_sub_recipe_cost ?? 0,
            require_all_items_ready_kds: branch?.require_all_items_ready_kds ?? 0,
            po_price_increase_pct: branch?.po_price_increase_pct ?? 0,
            kitchen_printer_ip: branch?.kitchen_printer_ip,
            service_fees_person: branch.service_fees_person,
            service_fees: branch.service_fees,
            print_tax: branch.print_tax,
            latitude: branch.latitude || "",
            longitude: branch.longitude || "",
            offline_enable: branch.offline_enable,
            order_pickup_time: branch.order_pickup_time || "",
            order_complete_time: branch.order_complete_time || "",
            feedback_url: branch.feedback_url || "",
            restaurant_name: branch.md_accPI?.restaurant_name ?? "",
            journal_name: branch.md_accPI?.journal_name ?? "",
            functional_area: branch.md_accPI?.functional_area ?? "",
            budget_center: branch.md_accPI?.budget_center ?? "",
            cost_center: branch.md_accPI?.cost_center ?? "",
            retail_channel: branch.md_accPI?.retail_channel ?? "",
            sales_account: accountSale1,
            discount_account: accountDiscount1,
            tax_account: accountTax1,
            cogs_account: accountCogs1,
            pos_fee_account: accountRevenue1,
            edit: true,
          });
          setPaymentTypeTax(branch.payment_tax);
          if (branch.province_id) {
            fetchCitiesByProvince(branch.province_id);
          } else {
            setCityList([]);
          }
        }
        setLoading(false);
      }catch {
        setLoading(false);
        ToastError({title: `${_t(t("Please try again"))}`})
      }
    
    };
  
    //update branch
    const handleUpdateBranch = (e) => {
      e.preventDefault();
      let deliveryIp = {};
      
      newRow?.length && newRow.forEach((ip)=>{
        if(ip.user !== null && ip.user !== "" && typeof(ip.user) == "object"){
          deliveryIp = {
            ...deliveryIp,
            [ip.user.id]: ip.printer_ip,
          }
        } 
      })
      if(Object.keys(deliveryIp)?.length !== newRow?.length){
        ToastError({title: `${_t(t("Select User/Can't select user multiple time"))}`})
        return false
      }

      const keenuCheck = getFormattedKeenuIntegration(keenuRows, newBranch.payment_integration);
      if (!keenuCheck.valid) {
        ToastError({ title: `${_t(t(keenuCheck.error))}` });
        return false;
      }
      const keenuIntegration = keenuCheck.data;
      if(key === "pi_microsoft" && newBranch.restaurant_name){
        if(!newBranch.restaurant_name || !newBranch.journal_name || !newBranch.budget_center || 
          !newBranch.functional_area || !newBranch.cost_center || !newBranch.retail_channel || (!newBranch.sales_account) || 
          !newBranch.cogs_account || !newBranch.pos_fee_account || !newBranch.discount_account || !newBranch.tax_account){
            ToastError({title: `${_t(t("Please select all required fields for PI Microsoft"))}`})
          return;
        }
      }

    let bankDropData = [];

    if (key === "bank_drop" || bankDrop.restaurant_name) {

      if (!bankDrop.restaurant_name || !bankDrop.journal_name || !bankDrop.functional_area || !bankDrop.budget_center || !bankDrop.cost_center || !bankDrop.retail_channel || (!bankDrop.bank_drop_account) || (!bankDrop.expense_account) || (!bankDrop.trapped_account)) {
        ToastError({ title: `${_t(t("Please select all required fields for bank drop"))}` })
        return;
      }

      const bdId = bankDrop.bank_drop_account?.id;
      const expId = bankDrop.expense_account?.id;
      const trapId = bankDrop.trapped_account?.id;

      if (bdId === expId || bdId === trapId || expId === trapId) {
        ToastError({ title: `${_t(t("Bank drop account, expense account and trapped account must be different from each other"))}` })
        return;
      }

      bankDropData.push({
        restaurant_name: bankDrop.restaurant_name,
        journal_name: bankDrop.journal_name,
        functional_area: bankDrop.functional_area,
        budget_center: bankDrop.budget_center,
        cost_center: bankDrop.cost_center,
        retail_channel: bankDrop.retail_channel,
        bank_drop_account: bankDrop.bank_drop_account.id,
        expense_account: bankDrop.expense_account.id,
        trapped_account: bankDrop.trapped_account.id,
      });
    }

    let wastageAccountData = [];
    if (key === "fg_discard" || fgDiscard.restaurant_name) {
      if (!fgDiscard.restaurant_name || !fgDiscard.journal_name || !fgDiscard.functional_area || !fgDiscard.budget_center || !fgDiscard.cost_center || !fgDiscard.retail_channel || !fgDiscard.cogs_account || !fgDiscard.fg_discard_account) {
        console.log("fgDiscard", fgDiscard);
        ToastError({ title: `${_t(t("Please select all required fields for FG discard"))}` });
        return;
      }
      wastageAccountData.push({
        restaurant_name: fgDiscard.restaurant_name,
        journal_name: fgDiscard.journal_name,
        functional_area: fgDiscard.functional_area,
        budget_center: fgDiscard.budget_center,
        cost_center: fgDiscard.cost_center,
        retail_channel: fgDiscard.retail_channel,
        cogs_account: fgDiscard.cogs_account.id,
        fg_discard_account: fgDiscard.fg_discard_account.id,
      });
    }

    const mdAcc = [];
    const dupParty = {};
    const dupPartyName = [];

    if (mdAccounts && mdAccounts?.length) {
      mdAccounts.forEach((acc) => {
        if (!acc.party || !acc.restaurant_name || !acc.journal_name || !acc.budget_center ||
          !acc.functional_area || !acc.cost_center || !acc.retail_channel || (!acc.sales_account) ||
          !acc.cogs_account || !acc.pos_fee_account || !acc.discount_account || !acc.tax_account) {

        } else {
          if (dupParty[acc.party.id]) {
            dupPartyName.push(acc.party.name);
          }
          dupParty[acc.party.id] = true;
          mdAcc.push({
            party_id: acc.party.id,
            restaurant_name: acc.restaurant_name,
            journal_name: acc.journal_name,
            budget_center: acc.budget_center,
            functional_area: acc.functional_area,
            cost_center: acc.cost_center,
            retail_channel: acc.retail_channel,
            sales_account: acc.sales_account.id,
            discount_account: acc.discount_account.id,
            tax_account: acc.tax_account.id,
            cogs_account: acc.cogs_account.id,
            pos_fee_account: acc.pos_fee_account.id
          })
        }
      })
    }

    if (mdAccounts?.length !== mdAcc?.length) {
      ToastError({ title: `${_t(t("Please select all required fields MD"))}` })
      return;
    }

    // console.log("mdAccounts", mdAccounts,mdAcc);


    if (dupPartyName && dupPartyName?.length) {
      ToastError({ title: `${_t(t(`Duplicate party ${dupPartyName[0]}`))}` })
      return;
    }

    if (newBranch?.sales_acc?.id && (!newBranch.food_item || newBranch.food_item?.length === 0)) {
      ToastError({ title: `${_t(t(`Please select item`))}` })
      return;
    }

    const mdAccPI = newBranch.restaurant_name ? [{
      restaurant_name: newBranch.restaurant_name,
      journal_name: newBranch.journal_name,
      functional_area: newBranch.functional_area,
      budget_center: newBranch.budget_center,
      cost_center: newBranch.cost_center,
      retail_channel: newBranch.retail_channel,
      sales_account: newBranch.sales_account?.id ? newBranch.sales_account?.id : "",
      discount_account: newBranch.discount_account?.id ? newBranch.discount_account?.id : "",
      tax_account: newBranch.tax_account?.id ? newBranch.tax_account?.id : "",
      cogs_account: newBranch.cogs_account?.id ? newBranch.cogs_account?.id : "",
      pos_fee_account: newBranch.pos_fee_account?.id ? newBranch.pos_fee_account?.id : "",
    }] : [];

    const foodItem = newBranch.food_item?.length ? newBranch.food_item.map((item) => item.id) : [];

    const mdSaleAcc = newBranch.sales_acc && newBranch.sales_acc?.id ? {
      sale_account_id: newBranch.sales_acc?.id,
      food_item_id: foodItem,
    } : [];

      let fromTime = newBranch.fromTime ? moment(newBranch.fromTime).format('HH:mm') : "";
      let toTime = newBranch.toTime ? moment(newBranch.toTime).format('HH:mm') : "";
      let shiftEndTiming = newBranch.shift_end_timing ? moment(newBranch.shift_end_timing).format('HH') : "";
     
      setNewBranch({
        ...newBranch,
        uploading: true,
      });
      const branchUrl = BASE_URL + `/settings/update-branch`;
      let formData = new FormData();
      formData.append("id", newBranch.id);
      formData.append("name", newBranch.name);
      formData.append("code", newBranch.code);
      formData.append("phn_no", newBranch.phn_no);
      formData.append("address", newBranch.address);
      formData.append("province_id", newBranch.province_id || "");
      formData.append("city_id", newBranch.city_id || "");
      formData.append("delivery_time", newBranch.delivery_time);
      formData.append("branch_tax", newBranch.branch_tax);
      formData.append("branch_logo", newBranch.image);
      formData.append("forcast_sale", newBranch.forcast_sale || 0);
      formData.append("barcode_enable", newBranch.barcode_enable)
      formData.append("customer_screen_image", newBranch.customer_screen_image);
      formData.append("customer_screen_real_time", newBranch.customer_screen_real_time);
      formData.append("cancel_order", newBranch.cancel_order);
      formData.append("cancel_order_time", newBranch.cancel_order_time);
      formData.append("payment_integration", newBranch.payment_integration);
      formData.append("keenu_integration", JSON.stringify(keenuIntegration));
      formData.append("from_purchase_time", fromTime);
      formData.append("to_purchase_time", toTime);
      formData.append("shift_end_timing", shiftEndTiming);
      formData.append("print_name", newBranch.print_name);
      formData.append("sntn_no", newBranch.sntn_no);
      formData.append("fp_chain_code", newBranch.fp_chain_code);
      formData.append("fp_pos_vendor_id", newBranch.fp_pos_vendor_id);
      formData.append("longitude", newBranch.longitude);
      formData.append("offline_enable", newBranch.offline_enable);
      formData.append("order_pickup_time", newBranch.order_pickup_time);
      formData.append("order_complete_time", newBranch.order_complete_time);
      formData.append("feedback_url", newBranch.feedback_url);
      formData.append("latitude", newBranch.latitude);
      formData.append("editSlug", newBranch.editSlug);
      formData.append("fbr_integration", newBranch.fbrIntegration);
      formData.append("cbr_integration", newBranch.cbrIntegration);
      formData.append("kpra_integration", newBranch.kpraIntegration);
      formData.append("pbr_integration", newBranch.pbrIntegration);
      formData.append("fbr_pos_registration_no", newBranch.fbrPosRegistrationNo);
      formData.append("fbr_pos_token", newBranch.fbrPosToken);
      formData.append("fbr_pct_code", newBranch.fbrPctCode);
      formData.append("status", newBranch.status);
      formData.append("sbr_integration", newBranch.sbrIntegration);
      //formData.append("sbr_payment_type", newBranch.sbrPaymentType);
      formData.append("sbr_ntn", newBranch.sbrNtn);
      formData.append("sbr_pos_id", newBranch.sbrPosId);
      formData.append("sbr_user_id", newBranch.sbrUserId);
      formData.append("sbr_user_password", newBranch.sbrUserPassword);
      formData.append("direct_ip_print", newBranch.direct_ip_print);
      formData.append("customer_counter_ip", newBranch.customer_counter_ip);
      formData.append("print_pos_setting", newBranch.print_pos_setting);
      formData.append("max_qty_check_purchase", newBranch.max_qty_check_purchase);
      formData.append("max_pi_qty_check", newBranch.max_pi_qty_check);
      formData.append("is_production_qty_editable", newBranch.is_production_qty_editable);
      formData.append("table_waiter", newBranch.table_waiter);
      formData.append("branch_self_order", newBranch.branch_self_order);
      // Persist the image display preference when editing a branch too.
      formData.append("dm_image_display", newBranch.dm_image_display);
      formData.append("dm_addon_image_display", newBranch.dm_addon_image_display ?? 1);
      formData.append("qsr_card_payment", newBranch.qsr_card_payment ?? 0);
      formData.append("allow_negative_stock", newBranch.allow_negative_stock);
      formData.append("dc_edit", newBranch.dc_edit);
      formData.append("item_wise_discount", newBranch.item_wise_discount);
      formData.append("calculate_sub_recipe_cost", newBranch.calculate_sub_recipe_cost);
      formData.append("require_all_items_ready_kds", newBranch.require_all_items_ready_kds);
      formData.append("po_price_increase_pct", newBranch.po_price_increase_pct || 0);
      formData.append("kitchen_printer_ip", JSON.stringify(deliveryIp));
      formData.append("auto_purchase_manage", newBranch.auto_purchase_manage);
      formData.append("default_to_branch_id", newBranch.default_to_branch_id);
      formData.append("auto_replenish_document", newBranch.auto_replenish_document || "");
      formData.append("service_fees_person", newBranch.service_fees_person);
      formData.append("service_fees", newBranch.service_fees);
      formData.append("print_tax", newBranch.print_tax);
      formData.append("auto_accept", newBranch.auto_accept ? 1 : 0);
      formData.append("consolidated_kot", newBranch.consolidated_kot ? 1 : 0);
      formData.append("consolidated_ip", newBranch.consolidated_ip);
      formData.append("ideal_food_cost", newBranch.ideal_food_cost || 0); 
      formData.append("md_accounts", JSON.stringify(mdAcc));
      formData.append("md_accPI", JSON.stringify(mdAccPI));
      formData.append("md_item_accounts", JSON.stringify(mdSaleAcc));

    formData.append("bank_drop", JSON.stringify(bankDropData));
    formData.append("md_accFgd", JSON.stringify(wastageAccountData));
    formData.append("menu", JSON.stringify(menuData));
    formData.append("footer_desc", menuData.footer_desc || "");

      let tempArray = [];
      sbrPaymentType.map((Item) => {
        tempArray.push(Item.id);
      });
      formData.append("payment_type_id", tempArray);
  
      let tempData = Object.entries(paymentTypeTax);
      tempData.map((item) => {
        formData.append("payment_type_tax[]", item);
      });
  
      return axios
        .post(branchUrl, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setNewBranch({
            id:null,
            name: "",
            code: "",
            phn_no: "",
            address: "",
            province_id: "",
            city_id: "",
            delivery_time: "0",
            consolidated_ip:"",
            ideal_food_cost:"",
            forcast_sale: "",
            barcode_enable: 0,
            latitude:"",
            longitude:"",
            order_pickup_time: "",
            order_complete_time: "",
            feedback_url:"",
            image: null,
            customer_screen_image: null,
            direct_ip_print: 0,
            customer_counter_ip: "",
            customer_screen_real_time: 0,
            cancel_order: 0,
            cancel_order_time:"",
            payment_integration:"",
            fromTime: "",
            toTime: "",
            shift_end_timing: null,
            print_name: "",
            sntn_no:"",
            fp_chain_code: "",
            fp_pos_vendor_id: "",
            auto_accept: false,
            consolidated_kot:false,
            edit: false,
            fbrIntegration: false,
            cbrIntegration: false,
            kpraIntegration: false,
            pbrIntegration:false,
            fbrPosRegistrationNo: "",
            fbrPosToken: "",
            fbrPctCode: "",
            status:true,
            sbrIntegration: false,
            sbrPaymentType: [],
            sales_acc: null,
            food_item: null,
            sbrUserId: "",
            sbrUserPassword: "",
            editSlug: null,
            uploading: false,
            print_tax:"",
            table_waiter: 0,
            branch_self_order: 0,
            dm_image_display: 1,
            dm_addon_image_display: 1,
            qsr_card_payment: 0,
            allow_negative_stock: 1,
            dc_edit: 0,
            auto_purchase_manage: 0,
            default_to_branch_id: "",
            auto_replenish_document: "",
            calculate_sub_recipe_cost: 0,
            is_production_qty_editable: 0,
            require_all_items_ready_kds: 0,
            po_price_increase_pct: 0,
          });
          setNewRow([]);
          setBankDrop({
            restaurant_name: "",
            journal_name: "",
            functional_area: "",
            budget_center: "",
            cost_center: "",
            retail_channel: "",
            bank_drop_account: null,
            expense_account: null,
            trapped_account: null,
          });
          setFgDiscard({
            restaurant_name: "",
            journal_name: "",
            functional_area: "",
            budget_center: "",
            cost_center: "",
            retail_channel: "",
            cogs_account: null,
            fg_discard_account: null,
          });
          setMenuData({
            header_text: "",
            link_text: "",
            links: [],
            terms_conditions: "",
            footer_desc: ""
          });
          setGetBranchList(res.data[0]);
          setGetBranchforSearch(res.data[1]);
          setKeenuRows([]);
          setSearchedBranch({
            ...searchedBranch,
            list: res.data[1],
          });
          setLoading(false);
          ToastSuccess({title: `${_t(t("Branch has been updated"))}`})
          history.push("/dashboard/manage/restaurant/branches");         
        })
        .catch(() => {
          setLoading(false);
          setNewBranch({
            ...newBranch,
            uploading: false,
          });
          ToastError({title: `${_t(t("Please try again"))}`})
        });
    };
  
    const branchOptions = useMemo(() => {
      const branches = Array.isArray(branchForSearch) ? branchForSearch : [];
      
      if (!params?.id) {
        return branches
      }

    return branches
      .filter(b => String(b.id) !== String(params.id));
  }, [branchForListSearch, params]);

    return (
      <>
        <Helmet>
          <title>{_t(t("Branches"))}</title>
        </Helmet>
  
        {/* Add modal */}          
        {/* Add modal Ends*/}
  
        {/* main body */}
        <main id="main" data-simplebar>
          <div className="container-fluid">
            <div className="row t-mt-10 gx-2">
              {/* left Sidebar */}
              <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
                <ManageSidebar />
              </div>
              {/* left Sidebar ends */}
  
              {/* Rightbar contents */}
              <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
                <div className="t-bg-white">
                  <div className="fk-scroll--pos-menu" data-simplebar>
                    <div className="t-pl-15 t-pr-15">
                      {/* Loading effect */}
                      {newBranch.uploading === true || loading === true ? (
                        tableLoading()
                      ) : (
                        <div key="fragment3">
                          {/* next page data spin loading */}
                          {/* <div className={`${dataPaginating && "loading"}`}></div> */}
                          {/* spin loading ends */}
  
                          <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                            <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                              <ul className="t-list fk-breadcrumb">
                                <li className="fk-breadcrumb__list">
                                  <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {!newBranch.edit
                                  ? _t(t("Add new branch"))
                                  : _t(t("Update branch"))}
                                  </span>
                                </li>
                              </ul>
                            </div>
                            <div className="col-md-6 col-lg-7">
                              <div className="row gx-3 align-items-center">                                  
                              </div>
                            </div>
                          </div>
                          {/* form start here */}
                          <div key="fragment-branch-1">
                            <form
                              onSubmit={
                                !newBranch.edit ? handleSaveNewBranch : handleUpdateBranch
                              }
                              className="row card p-2 mx-3 mb-5 new-text-style"
                              autoComplete="off"
                            >
                              <Tabs
                                id="controlled-tab-example"
                                activeKey={key}
                                onSelect={(k) => setKey(k)}
                                className="custom-tabs mb-3"
                              >
                                <Tab eventKey="branch" title="Branch">
                                  {/* Branch Details & General Configuration */}
                                  <div
                                    className="card p-3 border-0 shadow-sm mb-4"
                                    style={branchActionStyles.sectionCard}
                                  >
                                    <div className="d-flex align-items-center justify-content-between mb-3 border-bottom pb-2">
                                      <div className="d-flex align-items-center">
                                        <div
                                          className="d-flex align-items-center justify-content-center mr-2 rounded"
                                          style={branchActionStyles.sectionIconBox("#e0f2fe", "#0284c7")}
                                        >
                                          <i className="fa fa-building-o" style={{ fontSize: "16px" }}></i>
                                        </div>
                                        <div>
                                          <h6 className="font-weight-bold text-dark mb-0" style={{ fontSize: "15px" }}>
                                            {_t(t("Branch Details & Operational Information"))}
                                          </h6>
                                          <small className="text-muted fk-sm-card__title">
                                            {_t(t("Configure branch identity, contact details, tax parameters, and partner settings"))}
                                          </small>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row">
                                      {branchGeneralFields.map((field) => (
                                        <React.Fragment key={field.name}>
                                          <BranchInputField
                                            {...field}
                                            value={newBranch[field.name]}
                                            onChange={field.onChange || handleSetNewBranch}
                                          />
                                          {field.name === "address" && (
                                            <>
                                              <div className="form-group mt-3 col-3">
                                                <label htmlFor="province_id" className="form-label" style={branchActionStyles.formLabel}>
                                                  {_t(t("Province/State"))}
                                                </label>
                                                <Select
                                                  options={provinceList}
                                                  getOptionLabel={(option) => option.name || ""}
                                                  getOptionValue={(option) => String(option.id)}
                                                  classNamePrefix="select"
                                                  styles={customStyle}
                                                  isClearable
                                                  value={
                                                    provinceList.find(function (item) {
                                                      return String(item.id) === String(newBranch.province_id);
                                                    }) || null
                                                  }
                                                  onChange={handleProvinceChange}
                                                  placeholder={_t(t("Province/State"))}
                                                />
                                              </div>
                                              <div className="form-group mt-3 col-3">
                                                <label htmlFor="city_id" className="form-label" style={branchActionStyles.formLabel}>
                                                  {_t(t("City"))}
                                                </label>
                                                <Select
                                                  options={cityList}
                                                  getOptionLabel={(option) => option.name || ""}
                                                  getOptionValue={(option) => String(option.id)}
                                                  classNamePrefix="select"
                                                  styles={customStyle}
                                                  isClearable
                                                  isDisabled={!newBranch.province_id}
                                                  value={
                                                    cityList.find(function (item) {
                                                      return String(item.id) === String(newBranch.city_id);
                                                    }) || null
                                                  }
                                                  onChange={handleCityChange}
                                                  placeholder={_t(t("Please select")) + " " + _t(t("City"))}
                                                />
                                              </div>
                                            </>
                                          )}
                                        </React.Fragment>
                                      ))}
                                    </div>
                                  </div>

                                  {/* Operational Timings & POS Preferences */}
                                  <div
                                    className="card p-3 border-0 shadow-sm mb-4"
                                    style={branchActionStyles.sectionCard}
                                  >
                                    <div className="d-flex align-items-center justify-content-between mb-3 border-bottom pb-2">
                                      <div className="d-flex align-items-center">
                                        <div
                                          className="d-flex align-items-center justify-content-center mr-2 rounded"
                                          style={branchActionStyles.sectionIconBox("#fef3c7", "#d97706")}
                                        >
                                          <i className="fa fa-clock-o" style={{ fontSize: "16px" }}></i>
                                        </div>
                                        <div>
                                          <h6 className="font-weight-bold text-dark mb-0" style={{ fontSize: "15px" }}>
                                            {_t(t("Operational Timings & POS Preferences"))}
                                          </h6>
                                          <small className="text-muted fk-sm-card__title">
                                            {_t(t("Configure order lead times, cancellation window, kitchen shifts, and receipt formats"))}
                                          </small>
                                        </div>
                                      </div>
                                    </div>

                                    {/* Order Timings */}
                                    <div className="row">
                                      <BranchInputField
                                        col="col-lg-4 col-md-6 col-12"
                                        label={_t(t("Order Pickup Time (minutes)"))}
                                        id="order_pickup_time"
                                        name="order_pickup_time"
                                        type="number"
                                        placeholder="e.g. 20"
                                        suffix="min"
                                        value={newBranch.order_pickup_time}
                                        onChange={handleSetNewBranch}
                                      />
                                      <BranchInputField
                                        col="col-lg-4 col-md-6 col-12"
                                        label={_t(t("Order Complete Time (minutes)"))}
                                        id="order_complete_time"
                                        name="order_complete_time"
                                        type="number"
                                        placeholder="e.g. 20"
                                        suffix="min"
                                        value={newBranch.order_complete_time}
                                        onChange={handleSetNewBranch}
                                      />
                                      <div className="col-lg-4 col-md-6 col-12 mb-3">
                                        <label htmlFor="cancel_order" className="form-label" style={branchActionStyles.formLabel}>
                                          {_t(t("Cancel Order Time"))}
                                        </label>
                                        <div className="d-flex align-items-center" style={{ minHeight: "38px" }}>
                                          <div className="form-check mr-2 mb-0 d-flex align-items-center">
                                            <input
                                              type="checkbox"
                                              className="form-check-input cursor-pointer m-0"
                                              style={branchActionStyles.checkbox18}
                                              id="cancel_order"
                                              name="cancel_order"
                                              onChange={handleCancelItem}
                                              checked={Boolean(newBranch.cancel_order)}
                                            />
                                          </div>
                                          {newBranch.cancel_order ? (
                                            <div className="position-relative flex-grow-1">
                                              <input
                                                type="number"
                                                className="form-control"
                                                onKeyDown={(evt) =>
                                                  ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) &&
                                                  evt.preventDefault()
                                                }
                                                min="1"
                                                required
                                                onWheel={(e) => e.target.blur()}
                                                id="cancel_order_time"
                                                name="cancel_order_time"
                                                onChange={handleSetNewBranch}
                                                placeholder={_t(t("Time in min"))}
                                                value={newBranch?.cancel_order_time || ""}
                                                style={{ ...branchActionStyles.formInput, paddingRight: "36px" }}
                                              />
                                              <span className="position-absolute" style={branchActionStyles.inputSuffix}>
                                                min
                                              </span>
                                            </div>
                                          ) : (
                                            <small className="text-muted ml-1 fk-sm-card__title">
                                              {_t(t("Enable to set cancel window"))}
                                            </small>
                                          )}
                                        </div>
                                      </div>
                                    </div>

                                    {/* Shift & PI Timings */}
                                    <div className="row mt-2 pt-2 border-top">
                                      <div className="col-lg-4 col-md-6 col-12 mb-3">
                                        <label htmlFor="from_date" className="form-label" style={branchActionStyles.formLabel}>
                                          {_t(t("Fg Pi From Time"))}
                                        </label>
                                        <DatePicker
                                          selected={newBranch.fromTime}
                                          onChange={(val) => handleTimeChange("fromTime", val)}
                                          showTimeSelect
                                          showTimeSelectOnly
                                          timeIntervals={15}
                                          timeCaption="Time"
                                          className="form-control table-text"
                                          dateFormat="hh:mm aa"
                                          dropdownMode="select"
                                          isClearable
                                        />
                                      </div>

                                      <div className="col-lg-4 col-md-6 col-12 mb-3">
                                        <label htmlFor="to_date" className="form-label" style={branchActionStyles.formLabel}>
                                          {_t(t("To Time"))}
                                        </label>
                                        <div className="d-flex align-items-center">
                                          <DatePicker
                                            selected={newBranch.toTime}
                                            onChange={(val) => handleTimeChange("toTime", val)}
                                            showTimeSelect
                                            showTimeSelectOnly
                                            timeIntervals={15}
                                            timeCaption="Time"
                                            className="form-control table-text"
                                            dropdownMode="select"
                                            dateFormat="hh:mm aa"
                                            isClearable
                                          />
                                          <div className="ml-2 lg-text" title="remove time">
                                            <i
                                              className="fa fa-close cursor-pointer text-danger"
                                              onClick={() => {
                                                setNewBranch((curr) => ({
                                                  ...curr,
                                                  fromTime: null,
                                                  toTime: null,
                                                }));
                                              }}
                                            ></i>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-lg-4 col-md-6 col-12 mb-3">
                                        <label htmlFor="shift_end_timing" className="form-label" style={branchActionStyles.formLabel}>
                                          {_t(t("Shift End Timing"))}
                                        </label>
                                        <div className="d-flex align-items-center">
                                          <DatePicker
                                            selected={newBranch.shift_end_timing}
                                            onChange={(val) => handleTimeChange("shift_end_timing", val)}
                                            showTimeSelect
                                            showTimeSelectOnly
                                            timeIntervals={60}
                                            timeCaption="Time"
                                            className="form-control table-text"
                                            dropdownMode="select"
                                            dateFormat="hh aa"
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    {/* POS Receipt Options & Payment Integration */}
                                    <div className="row mt-2 pt-2 border-top">
                                      <div className="col-lg-6 col-md-12 col-12 mb-2">
                                        <label className="form-label" style={branchActionStyles.formLabel}>
                                          {_t(t("POS Receipt Options"))}
                                        </label>
                                        <div className="d-flex flex-wrap align-items-center mt-1">
                                          {POS_RECEIPT_CONFIG.map((opt) => (
                                            <div className="form-check form-check-inline mr-4" key={opt.id}>
                                              <input
                                                type="radio"
                                                className="form-check-input pointer-cursor"
                                                id={opt.id}
                                                name="print_pos_setting"
                                                value={opt.value}
                                                onChange={handleSetNewBranch}
                                                checked={newBranch.print_pos_setting === opt.value}
                                              />
                                              <label
                                                className="form-check-label pointer-cursor ml-1"
                                                htmlFor={opt.id}
                                                style={{ fontSize: "14px", color: "#334155" }}
                                              >
                                                {_t(t(opt.labelKey))}
                                              </label>
                                            </div>
                                          ))}
                                        </div>
                                      </div>

                                      <div className="col-lg-6 col-md-12 col-12 mb-2">
                                        <label className="form-label" style={branchActionStyles.formLabel}>
                                          {_t(t("POS Payment Integration"))}
                                        </label>
                                        <div className="d-flex flex-wrap align-items-center mt-1">
                                          {POS_PAYMENT_CONFIG.map((opt) => (
                                            <div className="form-check form-check-inline mr-4" key={opt.id}>
                                              <input
                                                type="radio"
                                                className="form-check-input pointer-cursor"
                                                id={opt.id}
                                                name="payment_integration"
                                                value={opt.value}
                                                onChange={(e) => {
                                                  handleSetNewBranch(e);
                                                  if (e.target.value === "keenu" && keenuRows.length === 0) {
                                                    addKeenuRow();
                                                  }
                                                }}
                                                checked={newBranch.payment_integration === opt.value}
                                              />
                                              <label
                                                className="form-check-label pointer-cursor ml-1"
                                                htmlFor={opt.id}
                                                style={{ fontSize: "14px", color: "#334155" }}
                                              >
                                                {_t(t(opt.labelKey))}
                                              </label>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Keenu Payment Integration Setup */}
                                  {newBranch.payment_integration === "keenu" && (
                                    <div className="row mt-3">
                                      <div className="col-12">
                                        <div
                                          className="card p-3 border-0 shadow-sm"
                                          style={branchActionStyles.sectionCard}
                                        >
                                          <div className="d-flex align-items-center justify-content-between mb-3 border-bottom pb-2 flex-wrap">
                                            <div className="d-flex align-items-center">
                                              <div
                                                className="d-flex align-items-center justify-content-center mr-2 rounded"
                                                style={branchActionStyles.sectionIconBox("#ecfdf5", "#059669")}
                                              >
                                                <i className="fa fa-credit-card" style={{ fontSize: "16px" }}></i>
                                              </div>
                                              <div>
                                                <div className="d-flex align-items-center">
                                                  <h6 className="font-weight-bold text-dark mb-0" style={{ fontSize: "15px" }}>
                                                    {_t(t("Keenu Payment Integration"))}
                                                  </h6>
                                                  <span
                                                    className="badge badge-success ml-2 px-2 py-1"
                                                    style={{ fontSize: "11px", fontWeight: 600 }}
                                                  >
                                                    {keenuRows.length} {_t(t(keenuRows.length === 1 ? "Terminal" : "Terminals"))}
                                                  </span>
                                                </div>
                                                <small className="text-muted fk-sm-card__title">
                                                  {_t(t("Assign Till ID and Keenu ID per user terminal"))}
                                                </small>
                                              </div>
                                            </div>
                                            <button
                                              type="button"
                                              className="btn btn-sm btn-outline-success rounded"
                                              onClick={addKeenuRow}
                                            >
                                              <i className="fa fa-plus-circle mr-1"></i> {_t(t("Add Row"))}
                                            </button>
                                          </div>

                                          <div className="table-responsive pr-1" style={branchActionStyles.tableScrollBox}>
                                            <table className="table table-bordered-sm table-hover mb-0">
                                              <thead className="align-middle">
                                                <tr>
                                                  {keenuRows.length === 0 ? (
                                                    <th
                                                      scope="col"
                                                      className="table-text text-capitalize align-middle text-center"
                                                      style={{ width: "60px", minWidth: "60px" }}
                                                    >
                                                      <span className="t-mr-10 cursor-pointer" onClick={addKeenuRow}>
                                                        <i
                                                         className="fa fa-plus-circle cursor-pointer btn-add-icon"
                                                         style={branchActionStyles.tableActionIcon}
                                                         aria-hidden="true"
                                                        ></i>
                                                      </span>
                                                    </th>
                                                  ) : (
                                                    <th style={branchActionStyles.tableEmptyTh}></th>
                                                  )}
                                                  <th className="border text-center" style={{ minWidth: "220px" }}>
                                                    {_t(t("Select User"))} <span className="text-danger">*</span>
                                                  </th>
                                                  <th className="border text-center" style={{ minWidth: "160px" }}>
                                                    {_t(t("Till ID"))} <span className="text-danger">*</span>
                                                  </th>
                                                  <th className="border text-center" style={{ minWidth: "160px" }}>
                                                    {_t(t("Keenu ID"))} <span className="text-danger">*</span>
                                                  </th>
                                                </tr>
                                              </thead>
                                              {keenuRows && keenuRows.length > 0 ? (
                                                <tbody className="align-middle">
                                                  {keenuRows.map((kRow, index) => (
                                                    <tr className="align-middle" key={kRow.id || index}>
                                                      <td
                                                        className="table-text text-capitalize align-middle text-center table-firstChild"
                                                        style={branchActionStyles.tableColMinWidth}
                                                      >
                                                        {index === keenuRows.length - 1 && (
                                                          <span className="t-mr-10 cursor-pointer" onClick={addKeenuRow}>
                                                            <i
                                                              className="fa fa-plus-circle btn-add-icon"
                                                              style={branchActionStyles.tableActionIcon}
                                                              aria-hidden="true"
                                                            ></i>
                                                          </span>
                                                        )}
                                                        &nbsp;
                                                        <i
                                                          className="fa fa-minus-circle cursor-pointer text-danger"
                                                          style={branchActionStyles.tableActionIcon}
                                                          onClick={() => delKeenuRow(kRow.id)}
                                                        ></i>
                                                      </td>
                                                      <td className="table-text text-capitalize align-middle text-center table-Child">
                                                        <Select
                                                          options={adminStaffForSearch !== null ? adminStaffForSearch : []}
                                                          getOptionLabel={(option) => option.name}
                                                          getOptionValue={(option) => option.id}
                                                          classNamePrefix="select"
                                                          onChange={(user) => handleSetKeenuUser(index, user)}
                                                          value={kRow.user || null}
                                                          styles={customStyle}
                                                          menuPosition="fixed"
                                                          placeholder={_t(t("Please select items")) + ".."}
                                                        />
                                                      </td>
                                                      <td className="table-text text-capitalize align-middle text-center table-Child">
                                                        <input
                                                          type="text"
                                                          className="form-control table-Input text-center lg-text"
                                                          name="till_id"
                                                          onChange={(e) => handleKeenuInputChange(index, "till_id", e.target.value)}
                                                          value={kRow.till_id || ""}
                                                          placeholder={_t(t("Till ID"))}
                                                          required
                                                        />
                                                      </td>
                                                      <td className="table-text text-capitalize align-middle text-center table-Child">
                                                        <input
                                                          type="text"
                                                          className="form-control table-Input text-center lg-text"
                                                          name="keenu_id"
                                                          onChange={(e) => handleKeenuInputChange(index, "keenu_id", e.target.value)}
                                                          value={kRow.keenu_id || ""}
                                                          placeholder={_t(t("Keenu ID"))}
                                                          required
                                                        />
                                                      </td>
                                                    </tr>
                                                  ))}
                                                </tbody>
                                              ) : (
                                                <tbody>
                                                  <tr>
                                                    <td colSpan="4" className="text-center py-3 text-muted">
                                                      <i className="fa fa-info-circle mr-1"></i> {_t(t("No Keenu terminals added yet. Click 'Add Row' or '+' above to add user terminal."))}
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              )}
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {/* Auto Purchase & Restock Setup */}
                                  <div className="row mt-3">
                                    <div className="col-12">
                                      <div className="p-3 border rounded bg-light">
                                        <div className="row align-items-center">
                                          <div className="col-md-3">
                                            <label htmlFor="auto_purchase_manage" className="form-label d-block font-weight-md mb-2">
                                              {_t(t("Auto Purchase Setup"))}
                                            </label>
                                            <div className="d-flex align-items-center">
                                              <input
                                                type="checkbox"
                                                className="form-check-input pointer-cursor m-0"
                                                style={branchActionStyles.checkbox18}
                                                id="auto_purchase_manage"
                                                name="auto_purchase_manage"
                                                onChange={() => {
                                                  setNewBranch((curr) => ({
                                                    ...curr,
                                                    auto_purchase_manage: curr.auto_purchase_manage === 0 ? 1 : 0,
                                                  }));
                                                }}
                                                checked={parseInt(newBranch.auto_purchase_manage) === 1}
                                              />
                                              <span className="ml-2 sm-text text-muted">
                                                {parseInt(newBranch.auto_purchase_manage) === 1
                                                  ? _t(t("Enabled"))
                                                  : _t(t("Disabled"))}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="col-md-4 mt-2 mt-md-0">
                                            <label htmlFor="default_to_branch_id" className="form-label d-block mb-1 font-weight-md sm-text">
                                              {_t(t("Auto Purchase To Branch"))}
                                            </label>
                                            <Select
                                              classNamePrefix="select"
                                              name="default_to_branch_id"
                                              isClearable
                                              placeholder={_t(t("Select Branch"))}
                                              options={branchOptions}
                                              getOptionLabel={(option) => option.name}
                                              getOptionValue={(option) => option.id}
                                              value={newBranch.default_to_branch_id ?
                                                branchForListSearch[newBranch.default_to_branch_id] : null
                                              }
                                              styles={customStyle}
                                              onChange={(selected) => {
                                                setNewBranch((curr) => ({
                                                  ...curr,
                                                  default_to_branch_id: selected ? selected.id : "",
                                                }));
                                              }}
                                            />
                                          </div>
                                          <div className="col-md-4 mt-2 mt-md-0">
                                            <label htmlFor="auto_replenish_document" className="form-label d-block mb-1 sm-text font-weight-md">
                                              {_t(t("Auto Restock"))}
                                            </label>
                                            <select
                                              name="auto_replenish_document"
                                              id="auto_replenish_document"
                                              className="form-control new-sm-text select-arrow"
                                              value={newBranch.auto_replenish_document || ""}
                                              onChange={(e) => {
                                                const val = e.target.value === "" ? "" : e.target.value;
                                                setNewBranch((curr) => ({
                                                  ...curr,
                                                  auto_replenish_document: val,
                                                }));
                                              }}
                                            >
                                              <option value="">{_t(t("None"))}</option>
                                              <option value="purchase_order">{_t(t("Purchase Order"))}</option>
                                              <option value="purchase_invoice">{_t(t("Purchase Invoice"))}</option>
                                              <option value="store_requisition">{_t(t("Store Requisition"))}</option>
                                            </select>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Branch Feature Settings - Synchronized Checkbox Panel */}
                                  <div className="row mt-4">
                                    <div className="col-12">
                                      <div
                                        className="card p-3 border-0 shadow-sm"
                                        style={branchActionStyles.sectionCard}
                                      >
                                        <div className="d-flex align-items-center justify-content-between mb-3 border-bottom pb-2">
                                          <div className="d-flex align-items-center">
                                            <div
                                              className="d-flex align-items-center justify-content-center mr-2 rounded"
                                              style={branchActionStyles.sectionIconBox("#e0f2fe", "#0284c7")}
                                            >
                                              <i className="fa fa-sliders" style={{ fontSize: "16px" }}></i>
                                            </div>
                                            <div>
                                              <h6 className="font-weight-bold text-dark mb-0" style={{ fontSize: "15px" }}>
                                                {_t(t("Branch Feature Settings"))}
                                              </h6>
                                              <small className="text-muted fk-sm-card__title">
                                                {_t(t("Configure branch operational rules, permissions, and stock behaviors"))}
                                              </small>
                                            </div>
                                          </div>
                                          <span
                                            className="px-2 py-1"
                                            style={branchActionStyles.sectionBadge}
                                          >
                                            {branchFeatureCheckboxes.filter((item) => parseInt(newBranch[item.key]) === 1).length} / {branchFeatureCheckboxes.length} {_t(t("Active"))}
                                          </span>
                                        </div>

                                        <div className="row">
                                          {branchFeatureCheckboxes.map((item) => {
                                            const isChecked = parseInt(newBranch[item.key]) === 1;
                                            return (
                                              <div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-3" key={item.key}>
                                                <div
                                                  className="p-3 rounded d-flex align-items-center justify-content-between pointer-cursor"
                                                  onClick={() => handleToggleBranchOption(item.key)}
                                                  style={branchActionStyles.featureCard(isChecked)}
                                                >
                                                  <div className="pr-2" style={{ lineHeight: "1.1" }}>
                                                    <label
                                                      htmlFor={item.key}
                                                      className="mb-0 font-weight-bold pointer-cursor"
                                                      style={branchActionStyles.featureLabel(isChecked)}
                                                      onClick={(e) => e.preventDefault()}
                                                    >
                                                      {item.label}
                                                      {item.subtitle && (
                                                        <span className="text-danger ml-1" style={{ fontSize: "11px" }}>
                                                          {item.subtitle}
                                                        </span>
                                                      )}
                                                    </label>
                                                  </div>
                                                  <input
                                                    type="checkbox"
                                                    className="form-check-input pointer-cursor m-0"
                                                    id={item.key}
                                                    name={item.key}
                                                    checked={isChecked}
                                                    onChange={() => handleToggleBranchOption(item.key)}
                                                    onClick={(e) => e.stopPropagation()}
                                                    style={branchActionStyles.featureCheckbox}
                                                  />
                                                </div>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-3">
                                      <div className="mt-3">
                                        <label
                                          htmlFor="image"
                                          className="form-label d-block"
                                        >
                                            {_t(t("Image "))}
                                          <small className="text-secondary fk-sm-card__title">
                                            ({_t(t("300 x 300 Preferable"))})
                                          </small>
                                        </label>
                                        <input
                                          accept="image/*"
                                          type="file"
                                          className="form-control sm-text d-none"
                                          id="image"
                                          name="image"
                                          onChange={handleItemImage}
                                        />
                                        <label htmlFor="image" className="image-btn">
                                          Choose File
                                        </label>
                                        {newBranch?.image && (
                                          <>
                                            <span className="text-truncate d-inline-block" style={branchActionStyles.truncateFileName}>
                                              {newBranch.image?.name}
                                            </span>
                                            <button type="button" onClick={() => setNewBranch({ ...newBranch, image: null })} className="btn-close ml-2 cursor-pointer" aria-label="Close"></button>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-3">
                                      <div className="mt-3">
                                        <label
                                          htmlFor="print_name"
                                          className="form-label"
                                        >
                                          {_t(t("Print Name"))}
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          onWheel={(e) => e.target.blur()} 
                                          id="print_name"
                                          name="print_name"
                                          onChange={handleSetNewBranch}
                                          value={newBranch.print_name || ""}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-3">
                                      <div className="mt-3">
                                        <label
                                          htmlFor="sntn_no"
                                          className="form-label"
                                        >
                                          {_t(t("Sntn No"))}
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          onWheel={(e) => e.target.blur()} 
                                          id="sntn_no"
                                          name="sntn_no"
                                          onChange={handleSetNewBranch}
                                          value={newBranch.sntn_no || ""}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-3">
                                      <div className="mt-3">
                                        <label
                                          htmlFor="customer_screen_image"
                                          className="form-label d-block"
                                        >
                                          {_t(t("Upload image/ video customer"))}
                                        </label>
                                        <input
                                          accept="image/*,video/*"
                                          type="file"
                                          className="form-control sm-text d-none"
                                          id="customer_screen_image"
                                          name="customer_screen_image"
                                          onChange={handleItemImage}
                                        />
                                        <label htmlFor="customer_screen_image" className="image-btn">
                                          Choose File
                                        </label>
                                        {newBranch?.customer_screen_image && (
                                          <>
                                            <span className="text-truncate d-inline-block" style={branchActionStyles.truncateFileName}>
                                              {newBranch.customer_screen_image?.name}
                                            </span>
                                            <button type="button" onClick={() => setNewBranch({ ...newBranch, customer_screen_image: null })} className="btn-close ml-2 cursor-pointer" aria-label="Close"></button>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row"> 
                                    <div className="ml-0 col-9 table-responsive mt-3 pr-1" style={branchActionStyles.tableScrollBox}>
                                      <table className="table table-bordered-sm table-hover">
                                        <thead className="align-middle">
                                          <tr>
                                            {newRow.length === 0 ? (
                                              <th
                                                scope="col"
                                                className="table-text text-capitalize align-middle text-center"
                                                style={{ width: "65px", minWidth: "65px" }}
                                              >
                                                <span className="cursor-pointer" onClick={addNewRow} title={_t(t("Add Row"))}>
                                                  <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={branchActionStyles.tableActionIcon} aria-hidden="true"></i>
                                                </span>
                                              </th>
                                            ) : (
                                              <th style={{ ...branchActionStyles.tableEmptyTh, width: "65px", minWidth: "65px" }}></th>
                                            )}
                                            <th className="border text-center">{_t(t("Select User"))}</th>
                                            <th className="border text-center">{_t(t("Customer Counter IP"))}</th>
                                          </tr> 
                                        </thead>  
                                        {newRow && newRow.length > 0 ? (
                                          <tbody className="align-middle">
                                            {newRow.map((printerIp, index) => (
                                              <tr className="align-middle" key={printerIp.id || index}>
                                                <td className="table-text text-capitalize align-middle text-center table-firstChild" style={branchActionStyles.tableColMinWidth}>
                                                  <div className="d-flex align-items-center justify-content-center">
                                                    {index === newRow.length - 1 && (
                                                      <i
                                                        className="fa fa-plus-circle cursor-pointer btn-add-icon mr-2"
                                                        style={branchActionStyles.tableActionIcon}
                                                        onClick={addNewRow}
                                                        aria-hidden="true"
                                                        title={_t(t("Add Row"))}
                                                      ></i>
                                                    )}
                                                    <i
                                                      className="fa fa-minus-circle cursor-pointer text-danger"
                                                      style={branchActionStyles.tableActionIcon} 
                                                      onClick={() => delRow(printerIp.id)}
                                                      title={_t(t("Remove Row"))}
                                                    ></i>
                                                  </div>
                                                </td>
                                                <td className="table-text text-capitalize align-middle text-center table-Child">
                                                  <Select
                                                    options={adminStaffForSearch !== null ? adminStaffForSearch : []}
                                                    getOptionLabel={(option) => option.name}
                                                    getOptionValue={(option) => option.id}
                                                    classNamePrefix="select"
                                                    onChange={(e) => handleSetUser(index, e)}
                                                    value={printerIp.user}
                                                    styles={customStyle}
                                                    menuPosition="fixed"
                                                    placeholder={_t(t("Please select items")) + ".."}                                                
                                                  />
                                                </td>
                                                <td className="table-text text-capitalize align-middle text-center table-Child">
                                                  <input 
                                                    type="text"
                                                    className="form-control table-Input text-center lg-text"
                                                    id={printerIp.id}
                                                    name={printerIp.id}
                                                    onChange={(e) => handlePrinterIp(index, e)}
                                                    value={printerIp.printer_ip ? printerIp.printer_ip : ""}
                                                    placeholder="e.g: 192.168..."
                                                    required
                                                  />
                                                </td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        ) : null}
                                      </table>
                                    </div>  
                                  </div>
                                    
                                  {/* Printing & Order Automation Card */}
                                  <div className="row mt-4">
                                    <div className="col-12">
                                      <div
                                        className="card p-3 border-0 shadow-sm"
                                        style={branchActionStyles.sectionCard}
                                      >
                                        <div className="d-flex align-items-center justify-content-between mb-3 border-bottom pb-2">
                                          <div className="d-flex align-items-center">
                                            <div
                                              className="d-flex align-items-center justify-content-center mr-2 rounded"
                                              style={branchActionStyles.sectionIconBox("#ede9fe", "#6d28d9")}
                                            >
                                              <i className="fa fa-print" style={{ fontSize: "16px" }}></i>
                                            </div>
                                            <div>
                                              <h6 className="font-weight-bold text-dark mb-0" style={{ fontSize: "15px" }}>
                                                {_t(t("Printing & Order Automation"))}
                                              </h6>
                                              <small className="text-muted fk-sm-card__title">
                                                {_t(t("Manage automated order acceptance and network printing modes"))}
                                              </small>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="row">
                                          {/* Auto Acceptance */}
                                          <div className="col-md-4 mb-2">
                                            <div
                                              className="p-3 rounded h-100 d-flex flex-column justify-content-between"
                                              style={branchActionStyles.automationCard(newBranch.auto_accept)}
                                            >
                                              <div>
                                                <div className="d-flex align-items-center justify-content-between mb-1">
                                                  <span className="font-weight-bold text-dark" style={{ fontSize: "14px" }}>
                                                    {_t(t("Auto Acceptance"))}
                                                  </span>
                                                  <Switch
                                                    onChange={handleChecked}
                                                    checked={Boolean(newBranch.auto_accept)}
                                                    className="react-switch"
                                                    name="auto_accept"
                                                    id="auto_accept"
                                                    height={20}
                                                    width={42}
                                                    onColor="#10b981"
                                                    offColor="#cbd5e1"
                                                    uncheckedIcon={false}
                                                    checkedIcon={false}
                                                  />
                                                </div>
                                                <small className="text-muted d-block mb-1 fk-sm-card__title">
                                                  {_t(t("Automatically accept online orders without manual confirmation"))}
                                                </small>
                                              </div>
                                              <div className="mt-1">
                                                <span
                                                  className="badge px-2 py-1"
                                                  style={branchActionStyles.automationBadge(newBranch.auto_accept)}
                                                >
                                                  {newBranch.auto_accept ? _t(t("Auto-Accept Active")) : _t(t("Manual Acceptance"))}
                                                </span>
                                              </div>
                                            </div>
                                          </div>

                                          {/* Consolidated KOT */}
                                          <div className="col-md-4 mb-2">
                                            <div
                                              className="p-3 rounded h-100 d-flex flex-column justify-content-between"
                                              style={branchActionStyles.automationCard(newBranch.consolidated_kot)}
                                            >
                                              <div>
                                                <div className="d-flex align-items-center justify-content-between mb-1">
                                                  <span className="font-weight-bold text-dark" style={{ fontSize: "14px" }}>
                                                    {_t(t("Consolidated KOT"))}
                                                  </span>
                                                  <Switch
                                                    onChange={handleKotCheck}
                                                    checked={Boolean(newBranch.consolidated_kot)}
                                                    className="react-switch"
                                                    name="consolidated_kot"
                                                    id="consolidated_kot"
                                                    height={20}
                                                    width={42}
                                                    onColor="#10b981"
                                                    offColor="#cbd5e1"
                                                    uncheckedIcon={false}
                                                    checkedIcon={false}
                                                  />
                                                </div>
                                                <small className="text-muted d-block mb-1 fk-sm-card__title">
                                                  {_t(t("Print grouped kitchen order ticket to a dedicated printer IP"))}
                                                </small>
                                              </div>

                                              {newBranch.consolidated_kot ? (
                                                <div className="mt-2 pt-2 border-top">
                                                  <label htmlFor="consolidated_ip" className="form-label mb-1 font-weight-bold text-dark" style={{ fontSize: "12px" }}>
                                                    {_t(t("Consolidated KOT IP"))} <span className="text-danger">*</span>
                                                  </label>
                                                  <div className="position-relative">
                                                    <i
                                                      className="fa fa-print text-muted position-absolute"
                                                      style={branchActionStyles.kotIcon}
                                                    ></i>
                                                    <input
                                                      type="text"
                                                      className="form-control form-control-sm"
                                                      id="consolidated_ip"
                                                      name="consolidated_ip"
                                                      onChange={handleSetNewBranch}
                                                      value={newBranch.consolidated_ip || ""}
                                                      placeholder="192.168.1.100"
                                                      required
                                                      style={branchActionStyles.kotInput}
                                                    />
                                                  </div>
                                                </div>
                                              ) : (
                                                <div className="mt-1">
                                                  <span
                                                    className="badge px-2 py-1"
                                                    style={branchActionStyles.automationBadge(false)}
                                                  >
                                                    {_t(t("Disabled"))}
                                                  </span>
                                                </div>
                                              )}
                                            </div>
                                          </div>

                                          {/* Direct Print */}
                                          <div className="col-md-4 mb-2">
                                            <div
                                              className="p-3 rounded h-100 d-flex flex-column justify-content-between"
                                              style={branchActionStyles.automationCard(newBranch.direct_ip_print)}
                                            >
                                              <div>
                                                <div className="d-flex align-items-center justify-content-between mb-1">
                                                  <span className="font-weight-bold text-dark" style={{ fontSize: "14px" }}>
                                                    {_t(t("Direct Print"))}
                                                  </span>
                                                  <Switch
                                                    onChange={() =>
                                                      setNewBranch((curr) => ({
                                                        ...curr,
                                                        direct_ip_print: curr.direct_ip_print ? 0 : 1,
                                                      }))
                                                    }
                                                    checked={Boolean(newBranch.direct_ip_print)}
                                                    className="react-switch"
                                                    name="direct_ip_print"
                                                    id="direct_ip_print"
                                                    height={20}
                                                    width={42}
                                                    onColor="#10b981"
                                                    offColor="#cbd5e1"
                                                    uncheckedIcon={false}
                                                    checkedIcon={false}
                                                  />
                                                </div>
                                                <small className="text-muted d-block mb-1 fk-sm-card__title">
                                                  {_t(t("Direct raw network IP printing bypassing print spooler"))}
                                                </small>
                                              </div>
                                              <div className="mt-1">
                                                <span
                                                  className="badge px-2 py-1"
                                                  style={branchActionStyles.automationBadge(newBranch.direct_ip_print)}
                                                >
                                                  {newBranch.direct_ip_print ? _t(t("Direct IP Print Active")) : _t(t("Standard Printing"))}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Branch Operational Status Card */}
                                  <div className="row mt-3">
                                    <div className="col-12">
                                      <div
                                        className="card p-3 border-0 shadow-sm"
                                        style={branchActionStyles.statusCard(newBranch.status)}
                                      >
                                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                                          <div className="d-flex align-items-center mr-3">
                                            <div
                                              className="d-flex align-items-center justify-content-center rounded-circle mr-3"
                                              style={branchActionStyles.statusCircle(newBranch.status)}
                                            >
                                              <i className={`fa ${newBranch.status ? "fa-check-circle" : "fa-power-off"}`} style={{ fontSize: "20px" }}></i>
                                            </div>
                                            <div>
                                              <div className="d-flex align-items-center">
                                                <h6 className="font-weight-bold mb-0 mr-2 text-dark" style={{ fontSize: "15px" }}>
                                                  {_t(t("Branch Status"))}
                                                </h6>
                                                <span
                                                  className="badge px-2 py-1"
                                                  style={branchActionStyles.statusBadge(newBranch.status)}
                                                >
                                                  {newBranch.status ? _t(t("Active")) : _t(t("Inactive"))}
                                                </span>
                                              </div>
                                              <small className="text-muted fk-sm-card__title">
                                                {newBranch.status
                                                  ? _t(t("Branch is currently active and ready for POS operations"))
                                                  : _t(t("Branch is currently inactive and hidden from active POS sales"))}
                                              </small>
                                            </div>
                                          </div>
                                          <div className="d-flex align-items-center mt-2 mt-sm-0">
                                            <Switch
                                              onChange={handleChangeStatus}
                                              checked={Boolean(newBranch.status)}
                                              className="react-switch"
                                              name="status"
                                              id="status"
                                              height={24}
                                              width={48}
                                              onColor="#10b981"
                                              offColor="#cbd5e1"
                                              uncheckedIcon={false}
                                              checkedIcon={false}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Fiscal & Tax Authority Integrations Panel */}
                                  <div className="row mt-3">
                                    <div className="col-12">
                                      <div
                                        className="card p-3 border-0 shadow-sm"
                                        style={branchActionStyles.sectionCard}
                                      >
                                        <div className="d-flex align-items-center justify-content-between mb-3 border-bottom pb-2 flex-wrap">
                                          <div className="d-flex align-items-center mr-2">
                                            <div
                                              className="d-flex align-items-center justify-content-center mr-2 rounded"
                                              style={branchActionStyles.sectionIconBox("#e0e7ff", "#4338ca")}
                                            >
                                              <i className="fa fa-university" style={{ fontSize: "16px" }}></i>
                                            </div>
                                            <div>
                                              <h6 className="font-weight-bold text-dark mb-0" style={{ fontSize: "15px" }}>
                                                {_t(t("Fiscal & Tax Authority Integrations"))}
                                              </h6>
                                              <small className="text-muted fk-sm-card__title">
                                                {_t(t("Select a tax authority for real-time POS invoice synchronization"))}
                                              </small>
                                            </div>
                                          </div>
                                          <div className="mt-2 mt-sm-0">
                                            {activeFiscalAuthority ? (
                                              <span
                                                className="d-inline-flex align-items-center px-3 py-1"
                                                style={branchActionStyles.fiscalStatusPill(activeFiscalAuthority)}
                                              >
                                                <span
                                                  style={branchActionStyles.fiscalBadgeDot(activeFiscalAuthority.color)}
                                                />
                                                <i className={`fa ${activeFiscalAuthority.icon}`} style={{ fontSize: "11px", marginRight: "5px" }}></i>
                                                {activeFiscalAuthority.name} {_t(t("Active"))}
                                              </span>
                                            ) : (
                                              <span
                                                className="d-inline-flex align-items-center px-3 py-1 text-muted"
                                                style={branchActionStyles.fiscalStatusPill(null)}
                                              >
                                                <span
                                                  style={branchActionStyles.fiscalBadgeDot("#94a3b8")}
                                                />
                                                {_t(t("None Selected (Standard)"))}
                                              </span>
                                            )}
                                          </div>
                                        </div>

                                        <div className="row">
                                          {FISCAL_AUTHORITY_CONFIG.map((auth) => {
                                            const isSelected = Boolean(newBranch[auth.key]);
                                            return (
                                              <div className="col-12 col-sm-6 col-md-4 col-lg mb-2" key={auth.key}>
                                                <div
                                                  onClick={() => handleToggleFiscalAuthority(auth.key)}
                                                  className="py-2 px-3 rounded cursor-pointer h-100 position-relative"
                                                  role="button"
                                                  tabIndex={0}
                                                  onKeyDown={(e) => {
                                                    if (e.key === "Enter" || e.key === " ") {
                                                      e.preventDefault();
                                                      handleToggleFiscalAuthority(auth.key);
                                                    }
                                                  }}
                                                  style={branchActionStyles.fiscalAuthorityCard(isSelected, auth)}
                                                >
                                                  <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <span
                                                      className="badge"
                                                      style={branchActionStyles.fiscalAuthorityBadge(isSelected, auth)}
                                                    >
                                                      {auth.badge}
                                                    </span>
                                                    <input
                                                      type="checkbox"
                                                      id={auth.key}
                                                      name={auth.key}
                                                      checked={isSelected}
                                                      onChange={() => handleToggleFiscalAuthority(auth.key)}
                                                      onClick={(e) => e.stopPropagation()}
                                                      style={branchActionStyles.checkbox16}
                                                    />
                                                  </div>
                                                  <div className="font-weight-bold text-dark" style={{ fontSize: "14px" }}>
                                                    {_t(t(auth.titleKey))}
                                                  </div>
                                                  <small className="text-muted d-block" style={{ fontSize: "12px" }}>
                                                    {_t(t(auth.subtitleKey))}
                                                  </small>
                                                </div>
                                              </div>
                                            );
                                          })}
                                        </div>

                                        {/* Connected Fiscal Authority Configuration Box */}
                                        {activeFiscalAuthority && (
                                          <div
                                            className="mt-3 p-3 rounded"
                                            style={branchActionStyles.fiscalConfigContainer(activeFiscalAuthority)}
                                          >
                                            <div className="d-flex align-items-center justify-content-between pb-2 mb-2 border-bottom flex-wrap">
                                              <div className="d-flex align-items-center">
                                                <div
                                                  className="d-flex align-items-center justify-content-center mr-2 rounded"
                                                  style={branchActionStyles.sectionIconBox(activeFiscalAuthority.bg, activeFiscalAuthority.color)}
                                                >
                                                  <i className={`fa ${activeFiscalAuthority.icon}`} style={{ fontSize: "13.5px" }}></i>
                                                </div>
                                                <div>
                                                  <div className="d-flex align-items-center flex-wrap">
                                                    <span className="font-weight-bold text-dark mr-2" style={{ fontSize: "14px" }}>
                                                      {activeFiscalAuthority.name} {_t(t("Configuration & Credentials"))}
                                                    </span>
                                                    <span
                                                      className="badge"
                                                      style={branchActionStyles.fiscalConfigBadge(activeFiscalAuthority)}
                                                    >
                                                      {activeFiscalAuthority.fullName}
                                                    </span>
                                                  </div>
                                                  <small className="text-muted" style={{ fontSize: "11px" }}>
                                                    {_t(t("Enter required credentials to link POS transactions with"))} {activeFiscalAuthority.name}
                                                  </small>
                                                </div>
                                              </div>
                                            </div>

                                            {/* Hidden Payment Type select preserved for compatibility */}
                                            <div className="d-none">
                                              <Select
                                                value={sbrPaymentType}
                                                options={paymentTypeForSearch}
                                                getOptionLabel={(option) => option.name}
                                                getOptionValue={(option) => option.name}
                                                className="basic-multi-select table-text"
                                                classNamePrefix="select"
                                                isMulti={true}
                                                onChange={handleSetPaymentType}
                                              />
                                            </div>

                                            {/* FBR / KPRA / PBR / CBR Fields */}
                                            {((newBranch.fbrIntegration === true || newBranch.fbrIntegration === 1) ||
                                              (newBranch.cbrIntegration === true || newBranch.cbrIntegration === 1) ||
                                              (newBranch.kpraIntegration === true || newBranch.kpraIntegration === 1) ||
                                              (newBranch.pbrIntegration === true || newBranch.pbrIntegration === 1)) && (
                                              <div className="row">
                                                <div className="mt-2 col-12 col-md-4">
                                                  <label
                                                    htmlFor="fbrPosRegistrationNo"
                                                    className="form-label"
                                                    style={branchActionStyles.fiscalLabel}
                                                  >
                                                    {_t(t("POS Registration No"))}{" "}
                                                    <small className="text-danger">*</small>
                                                  </label>
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    id="fbrPosRegistrationNo"
                                                    name="fbrPosRegistrationNo"
                                                    fbrPosRegistrationNo="fbrPosRegistrationNo"
                                                    placeholder="e.g. 123456"
                                                    value={newBranch.fbrPosRegistrationNo || ""}
                                                    required
                                                    onChange={handleSetNewBranch}
                                                  />
                                                </div>

                                                <div className="mt-2 col-12 col-md-4">
                                                  <label
                                                    htmlFor="fbrPosToken"
                                                    className="form-label"
                                                    style={branchActionStyles.fiscalLabel}
                                                  >
                                                    {_t(t("Pos Token"))}{" "}
                                                    <small className="text-danger">*</small>
                                                  </label>
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    id="fbrPosToken"
                                                    name="fbrPosToken"
                                                    fbrPosToken="fbrPosToken"
                                                    placeholder="e.g. 6baffg110-386a-3f83-a8re"
                                                    value={newBranch.fbrPosToken || ""}
                                                    required
                                                    onChange={handleSetNewBranch}
                                                  />
                                                </div>

                                                <div className="mt-2 col-12 col-md-4">
                                                  <label
                                                    htmlFor="fbrPctCode"
                                                    className="form-label"
                                                    style={branchActionStyles.fiscalLabel}
                                                  >
                                                    {_t(t("PCT Code"))}{" "}
                                                    <small className="text-danger">*</small>
                                                  </label>
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    id="fbrPctCode"
                                                    name="fbrPctCode"
                                                    fbrPctCode="fbrPctCode"
                                                    placeholder="e.g. 232329"
                                                    value={newBranch.fbrPctCode || ""}
                                                    required
                                                    onChange={handleSetNewBranch}
                                                  />
                                                </div>
                                              </div>
                                            )}

                                            {/* SBR Fields */}
                                            {(newBranch.sbrIntegration === true || newBranch.sbrIntegration === 1) && (
                                              <div className="row">
                                                <div className="mt-2 col-12 col-sm-6 col-md-3">
                                                  <label
                                                    htmlFor="sbrNtn"
                                                    className="form-label"
                                                    style={branchActionStyles.fiscalLabel}
                                                  >
                                                    {_t(t("NTN"))}{" "}
                                                    <small className="text-danger">*</small>
                                                  </label>
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    id="sbrNtn"
                                                    name="sbrNtn"
                                                    sbrUserId="sbrNtn"
                                                    value={newBranch.sbrNtn || ""}
                                                    required
                                                    onChange={handleSetNewBranch}
                                                  />
                                                </div>

                                                <div className="mt-2 col-12 col-sm-6 col-md-3">
                                                  <label
                                                    htmlFor="sbrPosId"
                                                    className="form-label"
                                                    style={branchActionStyles.fiscalLabel}
                                                  >
                                                    {_t(t("Pos ID"))}{" "}
                                                    <small className="text-danger">*</small>
                                                  </label>
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    id="sbrPosId"
                                                    name="sbrPosId"
                                                    sbrPosId="sbrPosId"
                                                    value={newBranch.sbrPosId || ""}
                                                    required
                                                    onChange={handleSetNewBranch}
                                                  />
                                                </div>

                                                <div className="mt-2 col-12 col-sm-6 col-md-3">
                                                  <label
                                                    htmlFor="sbrUserId"
                                                    className="form-label"
                                                    style={branchActionStyles.fiscalLabel}
                                                  >
                                                    {_t(t("User Id"))}{" "}
                                                    <small className="text-danger">*</small>
                                                  </label>
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    id="sbrUserId"
                                                    name="sbrUserId"
                                                    sbrUserId="sbrUserId"
                                                    value={newBranch.sbrUserId || ""}
                                                    required
                                                    onChange={handleSetNewBranch}
                                                  />
                                                </div>

                                                <div className="mt-2 col-12 col-sm-6 col-md-3">
                                                  <label
                                                    htmlFor="sbrUserPassword"
                                                    className="form-label"
                                                    style={branchActionStyles.fiscalLabel}
                                                  >
                                                    {_t(t("Password"))}{" "}
                                                    <small className="text-danger">*</small>
                                                  </label>
                                                  <input
                                                    type="password"
                                                    className="form-control"
                                                    id="sbrUserPassword"
                                                    name="sbrUserPassword"
                                                    sbrUserPassword="sbrUserPassword"
                                                    value={newBranch.sbrUserPassword || ""}
                                                    required
                                                    onChange={handleSetNewBranch}
                                                  />
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </Tab> 
                                <Tab eventKey="payment_tax" title="Payment Type Tax">
                                  <div
                                    className="card p-3 border-0 shadow-sm mb-4"
                                    style={branchActionStyles.sectionCard}
                                  >
                                    <div className="d-flex align-items-center justify-content-between mb-3 border-bottom pb-2 flex-wrap">
                                      <div className="d-flex align-items-center mr-2">
                                        <div
                                          className="d-flex align-items-center justify-content-center mr-2 rounded"
                                          style={branchActionStyles.sectionIconBox("#eef2ff", "#4f46e5")}
                                        >
                                          <i className="fa fa-percent" style={{ fontSize: "16px" }}></i>
                                        </div>
                                        <div>
                                          <h6 className="font-weight-bold text-dark mb-0" style={{ fontSize: "15px" }}>
                                            {_t(t("Payment Type Tax Rates"))}
                                          </h6>
                                          <small className="text-muted fk-sm-card__title">
                                            {_t(t("Configure specific percentage tax rates applicable to individual payment methods"))}
                                          </small>
                                        </div>
                                      </div>
                                      <span className="px-2 py-1" style={branchActionStyles.sectionBadge}>
                                        {paymentTypeForSearch?.length || 0} {_t(t("Payment Types"))}
                                      </span>
                                    </div>

                                    <div className="table-responsive rounded border bg-white" style={{ maxHeight: "25rem", overflowY: "auto" }}>
                                      <table className="table table-hover mb-0">
                                        <thead className="bg-light align-middle">
                                          <tr>
                                            <th
                                              scope="col"
                                              className="text-capitalize align-middle text-center py-2.5 border-bottom font-weight-bold text-dark"
                                              style={{ width: "45%", fontSize: "13px" }}
                                            >
                                              {_t(t("Payment Type"))}
                                            </th>
                                            <th
                                              scope="col"
                                              className="text-capitalize align-middle text-center py-2.5 border-bottom font-weight-bold text-dark"
                                              style={{ width: "55%", fontSize: "13px" }}
                                            >
                                              {_t(t("Tax Percent"))}
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody className="align-middle">
                                          {paymentTypeForSearch && paymentTypeForSearch.map((item, i) => {
                                            return (
                                              <tr key={item.id || item.name || i}>
                                                <td className="text-capitalize align-middle text-center font-weight-bold text-dark" style={{ fontSize: "13.5px" }}>
                                                  <span className="d-inline-flex align-items-center">
                                                    <i className="fa fa-credit-card mr-2 text-muted" style={{ fontSize: "13px" }}></i>
                                                    {item.name}
                                                  </span>
                                                </td>
                                                <td className="align-middle text-center" style={{ maxWidth: "200px" }}>
                                                  <div className="position-relative d-inline-block" style={{ width: "100%", maxWidth: "260px" }}>
                                                    <input
                                                      type="number"
                                                      className="form-control"
                                                      min="0"
                                                      step="any"
                                                      onKeyDown={(evt) =>
                                                        ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) &&
                                                        evt.preventDefault()
                                                      }
                                                      onWheel={(e) => e.target.blur()}
                                                      id={item.name}
                                                      name={item.name}
                                                      onChange={handlePaymentTypeTax}
                                                      placeholder="0.00"
                                                      value={paymentTypeTax[item.name] || ""}
                                                      style={{ ...branchActionStyles.formInput, paddingRight: "36px", textAlign: "center" }}
                                                    />
                                                    <span className="position-absolute" style={branchActionStyles.inputSuffix}>
                                                      %
                                                    </span>
                                                  </div>
                                                </td>
                                              </tr>
                                            );
                                          })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </Tab>  
                                <Tab eventKey="microsoft" title="Microsoft Dynamics">
                                  <div
                                    className="card p-3 border-0 shadow-sm mb-4"
                                    style={branchActionStyles.sectionCard}
                                  >
                                    <div className="d-flex align-items-center justify-content-between mb-3 border-bottom pb-2 flex-wrap">
                                      <div className="d-flex align-items-center mr-2">
                                        <div
                                          className="d-flex align-items-center justify-content-center mr-2 rounded"
                                          style={branchActionStyles.sectionIconBox("#e0f2fe", "#0284c7")}
                                        >
                                          <i className="fa fa-cubes" style={{ fontSize: "16px" }}></i>
                                        </div>
                                        <div>
                                          <h6 className="font-weight-bold text-dark mb-0" style={{ fontSize: "15px" }}>
                                            {_t(t("Microsoft Dynamics Integration"))}
                                          </h6>
                                          <small className="text-muted fk-sm-card__title">
                                            {_t(t("Configure centralized sales accounts, POS items mapping, and multi-party ledger distribution"))}
                                          </small>
                                        </div>
                                      </div>
                                      <span className="px-2 py-1" style={branchActionStyles.sectionBadge}>
                                        {mdAccounts?.length || 0} {_t(t("Party Mappings"))}
                                      </span>
                                    </div>

                                    {/* Top Selects: Sale Account & Items */}
                                    <div className="row mb-3">
                                      <div className="col-md-4 mb-2">
                                        <label htmlFor="sales_acc" className="form-label" style={branchActionStyles.formLabel}>
                                          {_t(t("Sale Account"))}
                                        </label>
                                        <Select
                                          options={MdIntegrationForSearch ? MdIntegrationForSearch : []}
                                          getOptionLabel={(option) => option.account_name}
                                          getOptionValue={(option) => option.id}
                                          classNamePrefix="select"
                                          onChange={(acc) => handleSetAccounts("sales_acc", acc)}
                                          maxMenuHeight="11rem"
                                          value={newBranch.sales_acc}
                                          styles={customStyle}
                                          isClearable
                                          closeMenuOnSelect={true}
                                          placeholder={_t(t("Select sale acc")) + ".."}
                                        />
                                      </div>
                                      <div className="col-md-8 mb-2">
                                        <label htmlFor="food_item" className="form-label" style={branchActionStyles.formLabel}>
                                          {_t(t("Select Items"))}
                                        </label>
                                        <Select
                                          options={foodForPOS ? foodForPOS : []}
                                          getOptionLabel={(option) => option.name}
                                          getOptionValue={(option) => option.id}
                                          classNamePrefix="select"
                                          onChange={(food) => handleSetAccounts("food_item", food)}
                                          maxMenuHeight="11rem"
                                          value={newBranch.food_item}
                                          isClearable
                                          isMulti
                                          styles={customStyle}
                                          closeMenuOnSelect={true}
                                          placeholder={_t(t("Please select item")) + ".."}
                                        />
                                      </div>
                                    </div>

                                    {/* Dynamic Accounts Table */}
                                    <div
                                      className="table-responsive rounded border bg-white pr-1"
                                      style={{ maxHeight: "27rem", overflow: "auto" }}
                                    >
                                      <table className="table table-bordered-sm table-hover mb-0">
                                        <thead className="align-middle bg-light">
                                          <tr>
                                            {mdAccounts.length === 0 ? (
                                              <th
                                                scope="col"
                                                className="table-text text-capitalize align-middle text-center border-1 border"
                                                style={{ width: "60px" }}
                                              >
                                                <span className="t-mr-10 cursor-pointer" onClick={() => addNewMdRow()}>
                                                  <i className="fa fa-plus-circle btn-add-icon" style={{ fontSize: "20px" }} aria-hidden="true"></i>
                                                </span>
                                              </th>
                                            ) : (
                                              <th style={{ borderBottomColor: "lightgray", minWidth: "60px", width: "60px" }}></th>
                                            )}

                                            <th scope="col" className="table-text text-capitalize align-middle text-center border-1 border" style={{ minWidth: "13rem" }}>
                                              <span style={{ fontWeight: 600 }}>{_t(t("Party"))}</span>
                                            </th>
                                            <th scope="col" className="table-text text-capitalize align-middle text-center border-1 border" style={{ minWidth: "12rem" }}>
                                              <span style={{ fontWeight: 600 }}>{_t(t("Restaurant Name"))}</span>
                                            </th>
                                            <th scope="col" className="table-text text-capitalize align-middle text-center border-1 border" style={{ minWidth: "12rem" }}>
                                              <span style={{ fontWeight: 600 }}>{_t(t("Journal Name"))}</span>
                                            </th>
                                            <th scope="col" className="table-text text-capitalize align-middle text-center border-1 border" style={{ minWidth: "12rem" }}>
                                              <span style={{ fontWeight: 600 }}>{_t(t("Functional Area"))}</span>
                                            </th>
                                            <th scope="col" className="table-text text-capitalize align-middle text-center border-1 border" style={{ minWidth: "12rem" }}>
                                              <span style={{ fontWeight: 600 }}>{_t(t("Budget Center"))}</span>
                                            </th>
                                            <th scope="col" className="table-text text-capitalize align-middle text-center border-1 border" style={{ minWidth: "12rem" }}>
                                              <span style={{ fontWeight: 600 }}>{_t(t("Cost Center"))}</span>
                                            </th>
                                            <th scope="col" className="table-text text-capitalize align-middle text-center border-1 border" style={{ minWidth: "12rem" }}>
                                              <span style={{ fontWeight: 600 }}>{_t(t("Retail Center"))}</span>
                                            </th>
                                            <th scope="col" className="table-text text-capitalize align-middle text-center border-1 border" style={{ minWidth: "13rem" }}>
                                              <span style={{ fontWeight: 600 }}>{_t(t("Sale Account"))}</span>
                                            </th>
                                            <th scope="col" className="table-text text-capitalize align-middle text-center border-1 border" style={{ minWidth: "13rem" }}>
                                              <span style={{ fontWeight: 600 }}>{_t(t("Discount Account"))}</span>
                                            </th>
                                            <th scope="col" className="table-text text-capitalize align-middle text-center border-1 border" style={{ minWidth: "13rem" }}>
                                              <span style={{ fontWeight: 600 }}>{_t(t("Tax Account"))}</span>
                                            </th>
                                            <th scope="col" className="table-text text-capitalize align-middle text-center border-1 border" style={{ minWidth: "13rem" }}>
                                              <span style={{ fontWeight: 600 }}>{_t(t("Cogs Account"))}</span>
                                            </th>
                                            <th scope="col" className="table-text text-capitalize align-middle text-center border-1 border" style={{ minWidth: "13rem" }}>
                                              <span style={{ fontWeight: 600 }}>{_t(t("Pos Fee Account"))}</span>
                                            </th>
                                            {mdAccounts.length > 0 && <th style={{ borderBottomColor: "lightgray", minWidth: "60px", width: "60px" }}></th>}
                                          </tr>
                                        </thead>
                                        {mdAccounts && mdAccounts.length > 0 ? (
                                          <tbody className="align-middle">
                                            {mdAccounts.map((mdAcc, index) => {
                                              return (
                                                <tr className="align-middle" key={index}>
                                                  <td className="table-text text-capitalize align-middle text-center table-firstChild" style={{ minWidth: "60px", width: "60px" }}>
                                                    {index === (mdAccounts.length - 1) && (
                                                      <span className="t-mr-10 cursor-pointer" onClick={() => addNewMdRow()}>
                                                        <i className="fa fa-plus-circle btn-add-icon" style={{ fontSize: "20px" }} aria-hidden="true"></i>
                                                      </span>
                                                    )}
                                                    &nbsp;
                                                    <i
                                                      className="fa fa-minus-circle cursor-pointer text-danger"
                                                      style={{ fontSize: "20px" }}
                                                      onClick={() => delMdRow(index)}
                                                    ></i>
                                                  </td>
                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <Select
                                                      menuPlacement={index > 1 ? "top" : "bottom"}
                                                      menuPosition="fixed"
                                                      options={partyForSearch || []}
                                                      getOptionLabel={(option) => option.name}
                                                      getOptionValue={(option) => option.id}
                                                      classNamePrefix="select"
                                                      onChange={(value) => handleSetSelectChange(index, "party", value)}
                                                      maxMenuHeight="12.8rem"
                                                      value={mdAcc.party}
                                                      styles={customStyle}
                                                      isMenuOpen={true}
                                                      className="bank-table-input"
                                                      placeholder={_t(t("Please select party")) + ".."}
                                                    />
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      id="restaurant_name"
                                                      name="restaurant_name"
                                                      placeholder="Restaurant Name"
                                                      value={mdAcc.restaurant_name || ""}
                                                      onChange={(e) => handleSetChange(index, e)}
                                                      style={branchActionStyles.formInput}
                                                    />
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center" style={{ minWidth: "230px" }}>
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      id="journal_name"
                                                      name="journal_name"
                                                      value={mdAcc.journal_name || ""}
                                                      onChange={(e) => handleSetChange(index, e)}
                                                      style={branchActionStyles.formInput}
                                                    />
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center" style={{ minWidth: "240px" }}>
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      id="functional_area"
                                                      name="functional_area"
                                                      value={mdAcc.functional_area || ""}
                                                      onChange={(e) => handleSetChange(index, e)}
                                                      style={branchActionStyles.formInput}
                                                    />
                                                  </td>
                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      id="budget_center"
                                                      name="budget_center"
                                                      value={mdAcc.budget_center || ""}
                                                      onChange={(e) => handleSetChange(index, e)}
                                                      style={branchActionStyles.formInput}
                                                    />
                                                  </td>
                                                  <td className="table-text align-middle text-center">
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      id="cost_center"
                                                      name="cost_center"
                                                      value={mdAcc.cost_center || ""}
                                                      onChange={(e) => handleSetChange(index, e)}
                                                      style={branchActionStyles.formInput}
                                                    />
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      id="retail_channel"
                                                      name="retail_channel"
                                                      placeholder="e.g 9001403"
                                                      value={mdAcc.retail_channel || ""}
                                                      onChange={(e) => handleSetChange(index, e)}
                                                      style={branchActionStyles.formInput}
                                                    />
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <Select
                                                      menuPlacement={index > 1 ? "top" : "bottom"}
                                                      menuPosition="fixed"
                                                      options={MdIntegrationForSearch ? MdIntegrationForSearch : []}
                                                      getOptionLabel={(option) => option.account_name}
                                                      getOptionValue={(option) => option.id}
                                                      classNamePrefix="select"
                                                      onChange={(acc) => handleSetSelectChange(index, "sales_account", acc)}
                                                      maxMenuHeight="11rem"
                                                      value={mdAcc.sales_account}
                                                      styles={customStyle}
                                                      closeMenuOnSelect={true}
                                                      placeholder={_t(t("Please select sale account")) + ".."}
                                                    />
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <Select
                                                      menuPlacement={index > 1 ? "top" : "bottom"}
                                                      menuPosition="fixed"
                                                      options={MdIntegrationForSearch ? MdIntegrationForSearch : []}
                                                      getOptionLabel={(option) => option.account_name}
                                                      getOptionValue={(option) => option.id}
                                                      classNamePrefix="select"
                                                      onChange={(acc) => handleSetSelectChange(index, "discount_account", acc)}
                                                      maxMenuHeight="11rem"
                                                      value={mdAcc.discount_account}
                                                      styles={customStyle}
                                                      closeMenuOnSelect={true}
                                                      placeholder={_t(t("Please select discount account")) + ".."}
                                                    />
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <Select
                                                      menuPlacement={index > 1 ? "top" : "bottom"}
                                                      menuPosition="fixed"
                                                      options={MdIntegrationForSearch ? MdIntegrationForSearch : []}
                                                      getOptionLabel={(option) => option.account_name}
                                                      getOptionValue={(option) => option.id}
                                                      classNamePrefix="select"
                                                      onChange={(acc) => handleSetSelectChange(index, "tax_account", acc)}
                                                      maxMenuHeight="11rem"
                                                      value={mdAcc.tax_account}
                                                      styles={customStyle}
                                                      closeMenuOnSelect={true}
                                                      placeholder={_t(t("Please select tax account")) + ".."}
                                                    />
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <Select
                                                      menuPlacement={index > 1 ? "top" : "bottom"}
                                                      menuPosition="fixed"
                                                      options={MdIntegrationForSearch ? MdIntegrationForSearch : []}
                                                      getOptionLabel={(option) => option.account_name}
                                                      getOptionValue={(option) => option.id}
                                                      classNamePrefix="select"
                                                      maxMenuHeight="13rem"
                                                      onChange={(acc) => handleSetSelectChange(index, "cogs_account", acc)}
                                                      value={mdAcc.cogs_account}
                                                      styles={customStyle}
                                                      closeMenuOnSelect={true}
                                                      placeholder={_t(t("Please select cogs account")) + ".."}
                                                    />
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <Select
                                                      menuPlacement={index > 1 ? "top" : "bottom"}
                                                      menuPosition="fixed"
                                                      options={MdIntegrationForSearch ? MdIntegrationForSearch : []}
                                                      getOptionLabel={(option) => option.account_name}
                                                      getOptionValue={(option) => option.id}
                                                      classNamePrefix="select"
                                                      maxMenuHeight="13rem"
                                                      onChange={(acc) => handleSetSelectChange(index, "pos_fee_account", acc)}
                                                      value={mdAcc.pos_fee_account}
                                                      styles={customStyle}
                                                      closeMenuOnSelect={true}
                                                      placeholder={_t(t("Please select revenue account")) + ".."}
                                                    />
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center" style={{ minWidth: "60px", width: "60px" }}>
                                                    <i
                                                      className="fa fa-minus-circle cursor-pointer text-danger"
                                                      style={{ fontSize: "20px" }}
                                                      onClick={() => {
                                                        delMdRow(index);
                                                      }}
                                                    ></i>
                                                    &nbsp;
                                                    {index === (mdAccounts.length - 1) && (
                                                      <span className="t-mr-10 cursor-pointer" onClick={() => addNewMdRow()}>
                                                        <i className="fa fa-plus-circle btn-add-icon" style={{ fontSize: "20px" }} aria-hidden="true"></i>
                                                      </span>
                                                    )}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        ) : null}
                                      </table>
                                    </div>
                                  </div>
                                </Tab> 
                                <Tab eventKey="pi_microsoft" title="MD PI Settings">
                                  <div
                                    className="card p-3 border-0 shadow-sm mb-4"
                                    style={branchActionStyles.sectionCard}
                                  >
                                    <div className="d-flex align-items-center justify-content-between mb-3 border-bottom pb-2 flex-wrap">
                                      <div className="d-flex align-items-center mr-2">
                                        <div
                                          className="d-flex align-items-center justify-content-center mr-2 rounded"
                                          style={branchActionStyles.sectionIconBox("#ede9fe", "#6d28d9")}
                                        >
                                          <i className="fa fa-file-text-o" style={{ fontSize: "16px" }}></i>
                                        </div>
                                        <div>
                                          <h6 className="font-weight-bold text-dark mb-0" style={{ fontSize: "15px" }}>
                                            {_t(t("MD Purchase Invoice (PI) Settings"))}
                                          </h6>
                                          <small className="text-muted fk-sm-card__title">
                                            {_t(t("Configure financial dimensions and default ledger accounts for Purchase Invoices"))}
                                          </small>
                                        </div>
                                      </div>
                                    </div>

                                    {/* Financial Dimensions */}
                                    <div className="row">
                                      <BranchInputField
                                        col="col-lg-4 col-md-6 col-12"
                                        label={_t(t("Restaurant Name"))}
                                        id="restaurant_name"
                                        requiredShow={true}
                                        name="restaurant_name"
                                        placeholder="Restaurant Name"
                                        value={newBranch.restaurant_name}
                                        onChange={handleSetNewBranch}
                                      />
                                      <BranchInputField
                                        col="col-lg-4 col-md-6 col-12"
                                        label={_t(t("Journal Name"))}
                                        id="journal_name"
                                        requiredShow={true}
                                        name="journal_name"
                                        value={newBranch.journal_name}
                                        onChange={handleSetNewBranch}
                                      />
                                      <BranchInputField
                                        col="col-lg-4 col-md-6 col-12"
                                        label={_t(t("Functional Area"))}
                                        id="functional_area"
                                        requiredShow={true}
                                        name="functional_area"
                                        value={newBranch.functional_area}
                                        onChange={handleSetNewBranch}
                                      />
                                      <BranchInputField
                                        col="col-lg-4 col-md-6 col-12"
                                        label={_t(t("Budget Center"))}
                                        id="budget_center"
                                        requiredShow={true}
                                        name="budget_center"
                                        value={newBranch.budget_center}
                                        onChange={handleSetNewBranch}
                                      />
                                      <BranchInputField
                                        col="col-lg-4 col-md-6 col-12"
                                        label={_t(t("Cost Center"))}
                                        id="cost_center"
                                        requiredShow={true}
                                        name="cost_center"
                                        value={newBranch.cost_center}
                                        onChange={handleSetNewBranch}
                                      />
                                      <BranchInputField
                                        col="col-lg-4 col-md-6 col-12"
                                        label={_t(t("Retail Center"))}
                                        id="retail_channel"
                                        requiredShow={true}
                                        name="retail_channel"
                                        placeholder="e.g 9001403"
                                        value={newBranch.retail_channel}
                                        onChange={handleSetNewBranch}
                                      />
                                    </div>

                                    {/* Ledger Accounts Section */}
                                    <div className="row mt-2 pt-2 border-top">
                                      <div className="col-12 mb-2">
                                        <span className="font-weight-bold text-dark sm-text">
                                          {_t(t("Default Ledger Accounts"))}
                                        </span>
                                      </div>
                                      <div className="col-lg-4 col-md-6 col-12 mb-3">
                                        <label htmlFor="sales_account" className="form-label" style={branchActionStyles.formLabel}>
                                          {_t(t("Sale Account"))} <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                          options={MdIntegrationForSearch ? MdIntegrationForSearch : []}
                                          getOptionLabel={(option) => option.account_name}
                                          getOptionValue={(option) => option.id}
                                          classNamePrefix="select"
                                          onChange={(acc) => handleSetAccounts("sales_account", acc)}
                                          maxMenuHeight="11rem"
                                          value={newBranch.sales_account}
                                          styles={customStyle}
                                          isClearable
                                          closeMenuOnSelect={true}
                                          placeholder={_t(t("Please select sale account")) + ".."}
                                        />
                                      </div>
                                      <div className="col-lg-4 col-md-6 col-12 mb-3">
                                        <label htmlFor="discount_account" className="form-label" style={branchActionStyles.formLabel}>
                                          {_t(t("Discount Account"))} <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                          options={MdIntegrationForSearch ? MdIntegrationForSearch : []}
                                          getOptionLabel={(option) => option.account_name}
                                          getOptionValue={(option) => option.id}
                                          classNamePrefix="select"
                                          onChange={(acc) => handleSetAccounts("discount_account", acc)}
                                          maxMenuHeight="11rem"
                                          value={newBranch.discount_account}
                                          isClearable
                                          styles={customStyle}
                                          closeMenuOnSelect={true}
                                          placeholder={_t(t("Please select discount account")) + ".."}
                                        />
                                      </div>
                                      <div className="col-lg-4 col-md-6 col-12 mb-3">
                                        <label htmlFor="tax_account" className="form-label" style={branchActionStyles.formLabel}>
                                          {_t(t("Tax Account"))} <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                          options={MdIntegrationForSearch ? MdIntegrationForSearch : []}
                                          getOptionLabel={(option) => option.account_name}
                                          getOptionValue={(option) => option.id}
                                          classNamePrefix="select"
                                          onChange={(acc) => handleSetAccounts("tax_account", acc)}
                                          maxMenuHeight="11rem"
                                          value={newBranch.tax_account}
                                          isClearable
                                          styles={customStyle}
                                          closeMenuOnSelect={true}
                                          placeholder={_t(t("Please select tax account")) + ".."}
                                        />
                                      </div>
                                      <div className="col-lg-4 col-md-6 col-12 mb-3">
                                        <label htmlFor="cogs_account" className="form-label" style={branchActionStyles.formLabel}>
                                          {_t(t("Cogs Account"))} <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                          menuPlacement="top"
                                          options={MdIntegrationForSearch ? MdIntegrationForSearch : []}
                                          getOptionLabel={(option) => option.account_name}
                                          getOptionValue={(option) => option.id}
                                          classNamePrefix="select"
                                          maxMenuHeight="13rem"
                                          onChange={(acc) => handleSetAccounts("cogs_account", acc)}
                                          value={newBranch.cogs_account}
                                          styles={customStyle}
                                          isClearable
                                          closeMenuOnSelect={true}
                                          placeholder={_t(t("Please select cogs account")) + ".."}
                                        />
                                      </div>
                                      <div className="col-lg-4 col-md-6 col-12 mb-3">
                                        <label htmlFor="pos_fee_account" className="form-label" style={branchActionStyles.formLabel}>
                                          {_t(t("Pos Fee Account"))} <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                          menuPlacement="top"
                                          options={MdIntegrationForSearch ? MdIntegrationForSearch : []}
                                          getOptionLabel={(option) => option.account_name}
                                          getOptionValue={(option) => option.id}
                                          classNamePrefix="select"
                                          maxMenuHeight="13rem"
                                          onChange={(acc) => handleSetAccounts("pos_fee_account", acc)}
                                          value={newBranch.pos_fee_account}
                                          isClearable
                                          styles={customStyle}
                                          closeMenuOnSelect={true}
                                          placeholder={_t(t("Please select revenue account")) + ".."}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </Tab>
                                <Tab eventKey="bank_drop" title="MD Bank Drop">
                                  <MDBankDrop
                                    bankDrop={bankDrop}
                                    setBankDrop={setBankDrop}
                                    MdIntegrationForSearch={MdIntegrationForSearch}
                                    t={t}
                                  />
                                </Tab>
                                <Tab eventKey="fg_discard" title="MD FG Discard">
                                  <MDFGDiscard
                                    fgDiscard={fgDiscard}
                                    setFgDiscard={setFgDiscard}
                                    MdIntegrationForSearch={MdIntegrationForSearch}
                                    t={t}
                                  />
                                </Tab>
                                <Tab eventKey="menu" title="Menu">
                                  <div
                                    className="card p-3 border-0 shadow-sm mb-4"
                                    style={branchActionStyles.sectionCard}
                                  >
                                    <div className="d-flex align-items-center justify-content-between mb-3 border-bottom pb-2 flex-wrap">
                                      <div className="d-flex align-items-center mr-2">
                                        <div
                                          className="d-flex align-items-center justify-content-center mr-2 rounded"
                                          style={branchActionStyles.sectionIconBox("#fef3c7", "#d97706")}
                                        >
                                          <i className="fa fa-qrcode" style={{ fontSize: "16px" }}></i>
                                        </div>
                                        <div>
                                          <h6 className="font-weight-bold text-dark mb-0" style={{ fontSize: "15px" }}>
                                            {_t(t("Digital Menu & QR Settings"))}
                                          </h6>
                                          <small className="text-muted fk-sm-card__title">
                                            {_t(t("Configure branch digital menu landing page, external links, terms, and QR code"))}
                                          </small>
                                        </div>
                                      </div>
                                      <button
                                        type="button"
                                        className="btn rounded btn-primary d-inline-flex align-items-center px-3"
                                        onClick={() => setShowMenuQRModal(true)}
                                        style={{ height: "36px", fontSize: "13px" }}
                                      >
                                        <i className="fa fa-qrcode mr-2"></i> {_t(t("Generate QR"))}
                                      </button>
                                    </div>

                                    {/* This branch setting controls item and fallback images on the public menu. */}
                                    <div className="row mt-0 mb-2">
                                      <div className="col-lg-4 col-md-4 col-12 d-flex align-items-center mb-2 mb-md-0">
                                        <label htmlFor="dm_image_display" className="form-label mb-0 mr-2">
                                          {_t(t("Show Digital Menu Images"))}
                                        </label>
                                        <Switch
                                          onChange={(checked) => setNewBranch((curr) => ({
                                            ...curr,
                                            dm_image_display: checked ? 1 : 0,
                                          }))}
                                          checked={parseInt(newBranch.dm_image_display ?? 1) === 1}
                                          className="react-switch ml-1"
                                          name="dm_image_display"
                                          id="dm_image_display"
                                          height={20}
                                          width={42}
                                          offColor="#ee5253"
                                        />
                                      </div>
                                      <div className="col-lg-4 col-md-4 col-12 d-flex align-items-center mb-2 mb-md-0">
                                        <label htmlFor="dm_addon_image_display" className="form-label mb-0 mr-2">
                                          {_t(t("Show Images in Add-on Popup"))}
                                        </label>
                                        <Switch
                                          onChange={(checked) => setNewBranch((curr) => ({
                                            ...curr,
                                            dm_addon_image_display: checked ? 1 : 0,
                                          }))}
                                          checked={parseInt(newBranch.dm_addon_image_display ?? 1) === 1}
                                          className="react-switch ml-1"
                                          name="dm_addon_image_display"
                                          id="dm_addon_image_display"
                                          height={20}
                                          width={42}
                                          offColor="#ee5253"
                                        />
                                      </div>
                                      <div className="col-lg-4 col-md-4 col-12 d-flex align-items-center mb-2 mb-md-0">
                                        <label htmlFor="qsr_card_payment" className="form-label mb-0 mr-2">
                                          {_t(t("QSR Card Payment"))}
                                        </label>
                                        <Switch
                                          onChange={(checked) => setNewBranch((curr) => ({
                                            ...curr,
                                            qsr_card_payment: checked ? 1 : 0,
                                          }))}
                                          checked={parseInt(newBranch.qsr_card_payment ?? 0) === 1}
                                          className="react-switch ml-1"
                                          name="qsr_card_payment"
                                          id="qsr_card_payment"
                                          height={20}
                                          width={42}
                                          offColor="#ee5253"
                                        />
                                      </div>
                                    </div>

                                    {/* Menu Headers & Terms */}
                                    <div className="row">
                                      <div className="col-lg-6 col-md-6 col-12 mb-3">
                                        <label className="form-label" style={branchActionStyles.formLabel}>
                                          {_t(t("Menu Header"))}
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={menuData.header_text}
                                          onChange={(e) => setMenuData({ ...menuData, header_text: e.target.value })}
                                          placeholder={_t(t("Menu Header"))}
                                          style={branchActionStyles.formInput}
                                        />
                                      </div>
                                      <div className="col-lg-6 col-md-6 col-12 mb-3">
                                        <label className="form-label" style={branchActionStyles.formLabel}>
                                          {_t(t("Menu Link Text"))}
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={menuData.link_text}
                                          onChange={(e) => setMenuData({ ...menuData, link_text: e.target.value })}
                                          placeholder={_t(t("Menu Link Text"))}
                                          style={branchActionStyles.formInput}
                                        />
                                      </div>
                                       <div className="form-group col-12 mt-3">
                                        <label className="form-label" style={branchActionStyles.formLabel}>
                                          {_t(t("Menu Terms & Conditions"))}
                                        </label>
                                        <RichTextEditor
                                          value={menuData.terms_conditions}
                                          onChange={(val) => setMenuData({ ...menuData, terms_conditions: val })}
                                          placeholder={_t(t("Enter terms & conditions with headings and bullet points..."))}
                                        />
                                      </div>
                                      <div className="form-group col-12 mt-3">
                                        <label className="form-label" style={branchActionStyles.formLabel}>
                                          {_t(t("Menu Footer Description"))}
                                        </label>
                                        <RichTextEditor
                                          value={menuData.footer_desc}
                                          onChange={(val) => setMenuData({ ...menuData, footer_desc: val })}
                                          placeholder={_t(t("Enter footer description (e.g. timings, address, thank you note)..."))}
                                          minHeight="120px"
                                        />
                                      </div>
                                    </div>

                                    {/* Menu Links Table */}
                                    <div className="row mt-2 pt-2 border-top">
                                      <div className="col-12 mb-2 d-flex align-items-center justify-content-between">
                                        <span className="font-weight-bold text-dark sm-text">
                                          {_t(t("Menu Links"))}
                                        </span>
                                        <span className="px-2 py-1" style={branchActionStyles.sectionBadge}>
                                          {menuData.links?.length || 0} {_t(t("Links"))}
                                        </span>
                                      </div>
                                      <div className="col-12">
                                        <div className="table-responsive rounded border bg-white pr-1" style={{ maxHeight: "25rem", overflow: "auto" }}>
                                          <table className="table table-bordered-sm table-hover mb-0">
                                            <thead className="align-middle bg-light">
                                              <tr>
                                                {menuData.links.length === 0 ? (
                                                  <th scope="col" className="table-text text-capitalize align-middle text-center border-1 border" style={{ width: "60px" }}>
                                                    <span className="t-mr-10 cursor-pointer" onClick={addMenuLinkRow}>
                                                      <i className="fa fa-plus-circle btn-add-icon" style={{ fontSize: "20px" }} aria-hidden="true"></i>
                                                    </span>
                                                  </th>
                                                ) : (
                                                  <th style={{ borderBottomColor: "lightgray", minWidth: "60px", width: "60px" }}></th>
                                                )}
                                                <th scope="col" className="table-text text-capitalize align-middle text-center border-1 border" style={{ minWidth: "13rem" }}>
                                                  <span style={{ fontWeight: 600 }}>{_t(t("Label"))}</span>
                                                </th>
                                                <th scope="col" className="table-text text-capitalize align-middle text-center border-1 border" style={{ minWidth: "13rem" }}>
                                                  <span style={{ fontWeight: 600 }}>{_t(t("Link"))}</span>
                                                </th>
                                              </tr>
                                            </thead>
                                            {menuData.links && menuData.links.length > 0 ? (
                                              <tbody className="align-middle">
                                                {menuData.links.map((linkObj, index) => (
                                                  <tr className="align-middle" key={index}>
                                                    <td className="table-text text-capitalize align-middle text-center table-firstChild" style={{ minWidth: "60px", width: "60px" }}>
                                                      {index === (menuData.links.length - 1) && (
                                                        <span className="t-mr-10 cursor-pointer" onClick={addMenuLinkRow}>
                                                          <i className="fa fa-plus-circle btn-add-icon" style={{ fontSize: "20px" }} aria-hidden="true"></i>
                                                        </span>
                                                      )}
                                                      &nbsp;
                                                      <i
                                                        className="fa fa-minus-circle cursor-pointer text-danger"
                                                        style={{ fontSize: "20px" }}
                                                        onClick={() => removeMenuLinkRow(index)}
                                                      ></i>
                                                    </td>
                                                    <td className="table-text text-capitalize align-middle text-center">
                                                      <input
                                                        type="text"
                                                        className="form-control"
                                                        required
                                                        value={linkObj.label}
                                                        onChange={(e) => handleMenuLinkChange(index, "label", e.target.value)}
                                                        placeholder={_t(t("Label"))}
                                                        style={branchActionStyles.formInput}
                                                      />
                                                    </td>
                                                    <td className="table-text text-capitalize align-middle text-center">
                                                      <input
                                                        type="text"
                                                        className="form-control"
                                                        value={linkObj.link}
                                                        required
                                                        onChange={(e) => handleMenuLinkChange(index, "link", e.target.value)}
                                                        placeholder={_t(t("Link"))}
                                                        style={branchActionStyles.formInput}
                                                      />
                                                    </td>
                                                  </tr>
                                                ))}
                                              </tbody>
                                            ) : null}
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Tab>
                              </Tabs> 
                              <div className="row mt-4">
                                <div className="col-12 d-flex justify-content-end align-items-center">
                                <button
                                    type="button"
                                    className="btn rounded hov-btn mr-3"
                                    onClick={()=>(history.push("/dashboard/manage/restaurant/branches"))}
                                  >
                                    <i className="fa fa-arrow-left" aria-hidden="true"></i> {_t(t("Back"))}
                                  </button>
                                  {SAAS_APPLICATION == "YES"
                                    ? [
                                        newBranch.edit
                                          ? [
                                              <button
                                                type="submit"
                                                className="btn btn-primary rounded"
                                              >
                                                <i className="fa fa-floppy-o" aria-hidden="true"></i> Update
                                              </button>,
                                            ]
                                          : [
                                              checkBranchLimitState == "HAS-LIMIT" ? (
                                                <button
                                                  type="submit"
                                                  className="btn btn-primary rounded"
                                                >
                                                  <i className="fa fa-floppy-o" aria-hidden="true"></i> {!newBranch.edit
                                                    ? _t(t("Save"))
                                                    : _t(t("Update"))}
                                                </button>
                                              ) : (
                                                <button
                                                  type="button"
                                                  className="btn btn-primary rounded"
                                                  onClick={() => {
                                                    ToastError({title: `${"Your limit has expired"}`})
                                                    
                                                  }}
                                                >
                                                  {_t(t("disable"))}
                                                </button>
                                              ),
                                            ],
                                      ]
                                    : [
                                        <button
                                          type="submit"
                                          className="btn btn-primary rounded"
                                        >
                                          <i className="fa fa-floppy-o" aria-hidden="true"></i> {!newBranch.edit ? _t(t("Save")) : _t(t("Update"))}
                                        </button>,
                                      ]}

                                      {key=="pi_microsoft"?<button type="button" className="btn rounded hov-btn ml-3" onClick={(e)=>{
                                      e.stopPropagation();
                                      setNewBranch((curr)=>({
                                        ...curr,
                                        restaurant_name:"",
                                        journal_name: "",
                                        functional_area:"",
                                        budget_center:"",
                                        cost_center:"",
                                        retail_channel:"",
                                        sales_account: null,
                                        discount_account: null,
                                        tax_account: null,
                                        cogs_account: null,
                                        pos_fee_account: null,
                                      }))
                                    }}>Clear MD PI</button>:""}
                                </div>
                                {/* <div className="col-3">
                                  <button
                                    type="button"
                                    className="btn btn-primary w-100 x text-uppercase t-width-max rounded"
                                    onClick={()=>(history.push("/dashboard/manage/restaurant/branches"))}
                                  >
                                    {_t(t("BACK"))}
                                  </button>
                                </div> */}
                              </div>  
                            </form>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* Rightbar contents end*/}
            </div>
          </div>
        </main>
        {/* main body ends */}
        
        <MenuQRModal 
          show={showMenuQRModal}
          onHide={() => setShowMenuQRModal(false)}
          branchId={params.id || newBranch.id}
          branchName={newBranch.name}
        />
    </>
  );
}

export default BranchAction;



const MDBankDrop = ({
  bankDrop,
  setBankDrop,
  MdIntegrationForSearch,
  t,
}) => {
  const handeUpdateField = (e) => {
    if (!e?.target) return;
    const { name, value } = e.target;
    setBankDrop((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSetAccounts = (name, value) => {
    setBankDrop((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div
      className="card p-3 border-0 shadow-sm mb-4"
      style={branchActionStyles.sectionCard}
    >
      <div className="d-flex align-items-center justify-content-between mb-3 border-bottom pb-2 flex-wrap">
        <div className="d-flex align-items-center mr-2">
          <div
            className="d-flex align-items-center justify-content-center mr-2 rounded"
            style={branchActionStyles.sectionIconBox("#dcfce7", "#15803d")}
          >
            <i className="fa fa-university" style={{ fontSize: "16px" }}></i>
          </div>
          <div>
            <h6 className="font-weight-bold text-dark mb-0" style={{ fontSize: "15px" }}>
              {_t(t("Microsoft Dynamics Bank Drop Settings"))}
            </h6>
            <small className="text-muted fk-sm-card__title">
              {_t(t("Configure accounting dimensions, bank drop, expense, and trapped cash accounts"))}
            </small>
          </div>
        </div>
      </div>

      {/* Dimensions */}
      <div className="row">
        <BranchInputField
          col="col-lg-4 col-md-6 col-12"
          label={_t(t("Restaurant Name"))}
          id="restaurant_name_bank_drop"
          name="restaurant_name"
          requiredShow={true}
          placeholder="Restaurant Name"
          value={bankDrop.restaurant_name}
          onChange={handeUpdateField}
        />
        <BranchInputField
          col="col-lg-4 col-md-6 col-12"
          label={_t(t("Journal Name"))}
          id="journal_name_bank_drop"
          requiredShow={true}
          name="journal_name"
          value={bankDrop.journal_name}
          onChange={handeUpdateField}
        />
        <BranchInputField
          col="col-lg-4 col-md-6 col-12"
          label={_t(t("Functional Area"))}
          id="functional_area_bank_drop"
          name="functional_area"
          requiredShow={true}
          value={bankDrop.functional_area}
          onChange={handeUpdateField}
        />
        <BranchInputField
          col="col-lg-4 col-md-6 col-12"
          label={_t(t("Budget Center"))}
          id="budget_center_bank_drop"
          name="budget_center"
          requiredShow={true}
          value={bankDrop.budget_center}
          onChange={handeUpdateField}
        />
        <BranchInputField
          col="col-lg-4 col-md-6 col-12"
          label={_t(t("Cost Center"))}
          id="cost_center_bank_drop"
          name="cost_center"
          requiredShow={true}
          value={bankDrop.cost_center}
          onChange={handeUpdateField}
        />
        <BranchInputField
          col="col-lg-4 col-md-6 col-12"
          label={_t(t("Retail Center"))}
          id="retail_channel_bank_drop"
          name="retail_channel"
          requiredShow={true}
          placeholder="e.g 9001403"
          value={bankDrop.retail_channel}
          onChange={handeUpdateField}
        />
      </div>

      {/* Accounts */}
      <div className="row mt-2 pt-2 border-top">
        <div className="col-12 mb-2">
          <span className="font-weight-bold text-dark sm-text">
            {_t(t("Bank Drop Accounts"))}
          </span>
        </div>
        <div className="col-lg-4 col-md-6 col-12 mb-3">
          <label htmlFor="bank_drop_account" className="form-label" style={branchActionStyles.formLabel}>
            {_t(t("Bank Drop Account"))} <span className="text-danger">*</span>
          </label>
          <Select
            options={MdIntegrationForSearch ? MdIntegrationForSearch : []}
            getOptionLabel={(option) => option.account_name}
            getOptionValue={(option) => option.id}
            classNamePrefix="select"
            onChange={(acc) => handleSetAccounts("bank_drop_account", acc)}
            maxMenuHeight="11rem"
            value={bankDrop.bank_drop_account}
            styles={customStyle}
            isClearable
            closeMenuOnSelect={true}
            placeholder={_t(t("Please select bank drop account")) + ".."}
          />
        </div>
        <div className="col-lg-4 col-md-6 col-12 mb-3">
          <label htmlFor="expense_account" className="form-label" style={branchActionStyles.formLabel}>
            {_t(t("Expense Account"))} <span className="text-danger">*</span>
          </label>
          <Select
            options={MdIntegrationForSearch ? MdIntegrationForSearch : []}
            getOptionLabel={(option) => option.account_name}
            getOptionValue={(option) => option.id}
            classNamePrefix="select"
            onChange={(acc) => handleSetAccounts("expense_account", acc)}
            maxMenuHeight="11rem"
            value={bankDrop.expense_account}
            isClearable
            styles={customStyle}
            closeMenuOnSelect={true}
            placeholder={_t(t("Please select expense account")) + ".."}
          />
        </div>
        <div className="col-lg-4 col-md-6 col-12 mb-3">
          <label htmlFor="trapped_account" className="form-label" style={branchActionStyles.formLabel}>
            {_t(t("Trapped Account"))} <span className="text-danger">*</span>
          </label>
          <Select
            options={MdIntegrationForSearch ? MdIntegrationForSearch : []}
            getOptionLabel={(option) => option.account_name}
            getOptionValue={(option) => option.id}
            classNamePrefix="select"
            onChange={(acc) => handleSetAccounts("trapped_account", acc)}
            maxMenuHeight="11rem"
            value={bankDrop.trapped_account}
            isClearable
            styles={customStyle}
            closeMenuOnSelect={true}
            placeholder={_t(t("Please select trapped account")) + ".."}
          />
        </div>
      </div>
    </div>
  );
};

const MDFGDiscard = ({
  fgDiscard,
  setFgDiscard,
  MdIntegrationForSearch,
  t,
}) => {
  const handeUpdateField = (e) => {
    if (!e?.target) return;
    const { name, value } = e.target;
    setFgDiscard((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSetAccounts = (name, value) => {
    setFgDiscard((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div
      className="card p-3 border-0 shadow-sm mb-4"
      style={branchActionStyles.sectionCard}
    >
      <div className="d-flex align-items-center justify-content-between mb-3 border-bottom pb-2 flex-wrap">
        <div className="d-flex align-items-center mr-2">
          <div
            className="d-flex align-items-center justify-content-center mr-2 rounded"
            style={branchActionStyles.sectionIconBox("#fee2e2", "#b91c1c")}
          >
            <i className="fa fa-trash-o" style={{ fontSize: "16px" }}></i>
          </div>
          <div>
            <h6 className="font-weight-bold text-dark mb-0" style={{ fontSize: "15px" }}>
              {_t(t("Microsoft Dynamics FG Discard Settings"))}
            </h6>
            <small className="text-muted fk-sm-card__title">
              {_t(t("Configure accounting dimensions, COGS, and wastage accounts for finished goods discard"))}
            </small>
          </div>
        </div>
      </div>

      {/* Dimensions */}
      <div className="row">
        <BranchInputField
          col="col-lg-4 col-md-6 col-12"
          label={_t(t("Restaurant Name"))}
          id="restaurant_name_fg_discard"
          name="restaurant_name"
          requiredShow={true}
          placeholder="Restaurant Name"
          value={fgDiscard.restaurant_name}
          onChange={handeUpdateField}
        />
        <BranchInputField
          col="col-lg-4 col-md-6 col-12"
          label={_t(t("Journal Name"))}
          id="journal_name_fg_discard"
          name="journal_name"
          requiredShow={true}
          value={fgDiscard.journal_name}
          onChange={handeUpdateField}
        />
        <BranchInputField
          col="col-lg-4 col-md-6 col-12"
          label={_t(t("Functional Area"))}
          id="functional_area_fg_discard"
          name="functional_area"
          requiredShow={true}
          value={fgDiscard.functional_area}
          onChange={handeUpdateField}
        />
        <BranchInputField
          col="col-lg-4 col-md-6 col-12"
          label={_t(t("Budget Center"))}
          id="budget_center_fg_discard"
          name="budget_center"
          requiredShow={true}
          value={fgDiscard.budget_center}
          onChange={handeUpdateField}
        />
        <BranchInputField
          col="col-lg-4 col-md-6 col-12"
          label={_t(t("Cost Center"))}
          id="cost_center_fg_discard"
          name="cost_center"
          requiredShow={true}
          value={fgDiscard.cost_center}
          onChange={handeUpdateField}
        />
        <BranchInputField
          col="col-lg-4 col-md-6 col-12"
          label={_t(t("Retail Center"))}
          id="retail_channel_fg_discard"
          name="retail_channel"
          requiredShow={true}
          placeholder="e.g 9001403"
          value={fgDiscard.retail_channel}
          onChange={handeUpdateField}
        />
      </div>

      {/* Accounts */}
      <div className="row mt-2 pt-2 border-top">
        <div className="col-12 mb-2">
          <span className="font-weight-bold text-dark sm-text">
            {_t(t("FG Discard Accounts"))}
          </span>
        </div>
        <div className="col-lg-6 col-md-6 col-12 mb-3">
          <label htmlFor="cogs_account" className="form-label" style={branchActionStyles.formLabel}>
            {_t(t("Cogs Account"))} <span className="text-danger">*</span>
          </label>
          <Select
            options={MdIntegrationForSearch ? MdIntegrationForSearch : []}
            getOptionLabel={(option) => option.account_name}
            getOptionValue={(option) => option.id}
            classNamePrefix="select"
            onChange={(acc) => handleSetAccounts("cogs_account", acc)}
            maxMenuHeight="11rem"
            value={fgDiscard.cogs_account}
            styles={customStyle}
            isClearable
            closeMenuOnSelect={true}
            placeholder={_t(t("Please select cogs account")) + ".."}
          />
        </div>
        <div className="col-lg-6 col-md-6 col-12 mb-3">
          <label htmlFor="fg_discard_account" className="form-label" style={branchActionStyles.formLabel}>
            {_t(t("Wastage Account"))} <span className="text-danger">*</span>
          </label>
          <Select
            options={MdIntegrationForSearch ? MdIntegrationForSearch : []}
            getOptionLabel={(option) => option.account_name}
            getOptionValue={(option) => option.id}
            classNamePrefix="select"
            onChange={(acc) => handleSetAccounts("fg_discard_account", acc)}
            maxMenuHeight="11rem"
            value={fgDiscard.fg_discard_account}
            isClearable
            styles={customStyle}
            closeMenuOnSelect={true}
            placeholder={_t(t("Please select wastage account")) + ".."}
          />
        </div>
      </div>
    </div>
  );
};